import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import CurrencyInput from 'react-currency-input-field';
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import mockData from '../Components/mockData2'
import authInstance from '../Classes/AuthHandler';
import RejectPOAcceptance from '../Components/RejectPOAcceptance';
import CancelPOAcceptance from '../Components/CancelPOAcceptance';
import UploadPopUpPoAcceptance from '../Components/UploadPopUpPoAcceptance';
import UploadAcknowledgementPopUp from '../Components/UploadAcknowledgementPopUp';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import DropdownFlat from '../Components/DropdownFlat'
import swal from '@sweetalert/with-react';
import { GetBgDraftDocTableData } from '../store/actions/BGDraftDocAction'
import { GetPaymentTermDetailByPOId, GetDocumentsForAdvance, postApprovePOAcceptance, postUpdateAdvanceDocumentStatus, GetPaymentTermDetails, getPaymentTermDocuments, PaymentTermDocumentsApprovalByPMs, submitInvoiceDocuments, UpdateApprovalForAdvanceDocumentPartial, postMapAdvanceDocumentIDsToPO, UpdatePartialPaymentDetails, postAdditionalEmailId, GetDraftDocuments } from '../store/actions/poDetailsActions'
import { uploadFileforAdvanceDocuments, uploadFileGeneric, GenericUploadVersionFile } from '../store/actions/fileActions'
import { setInvoicePaymentMedium, getAllInvoices, updateStatusForFinance, GetAllInvoicesForSupplier, InsertInvoiceDetails, GetInvoiceDetailsForAPteamApproval } from '../store/actions/invoiceActions';
import { getallMasterData, GetAllCurrencyDetails } from '../store/actions/masterActions';
import env from '../ENV';
import AuthHandler from '../Classes/AuthHandler';
import toast from 'react-hot-toast';
import { Table, Alert, Accordion, Card, AccordionToggle, Button, ProgressBar } from 'react-bootstrap'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import { GenericGetCommentsbyDocumentID, GenericPostCommentsbyDocumentID } from './../store/actions/documentCommentAction';
import DocumentCommentsByDocumentIdPopUp from '../Components/DocumentCommentsByDocumentIdPopUp';
import FileVersionModal from '../Components/FileVersionModal';
import TableComp from '../Components/ReusableTable'
import {
    postPoTransmittleDocumnetDtails, GetTransmittalDocumentDetails, UpdateTransmittalDocumentDetails, GetClaimDetailsByPoId, postBGListDetails, getBGListDetails, getactionDetail
} from './../store/actions/expediting.Actions';
import POCommentPopUp from '../Components/POCommentPopUp';
import Switch from "react-switch";
import { GetGRNDetails, postGRNDetails } from '../store/actions/dispatchOrderDetailsActions';
import Select, { components } from "react-select"
import Loading from '../Components/Loader';
import { CircularProgressbar, CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';


const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
}


class PoAcceptanceTrail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            paymentMethod: [],
            selectedpaymentmethod: "",
            supplierName: "",
            select: true,
            OpenInFoModal: false,
            selectedBGRow: {},
            open: false,
            poId: mockData.PurchaseOrderId,
            CancelPOAcceptanceModal: false,
            ReviseModal: false,
            UploadPOAcceptanceModal: false,
            UploadAcknowledgementModal: false,
            opacity: "",
            CurrencyArray: [
                { value: "INR", label: "INR" },
                { value: "EUR", label: "EUR" },
                { value: "USD", label: "USD" },
                { value: "CNY", label: "CNY" }],
            checked: [],
            dataArray: [mockData.documents],
            poID: this.props.location.state.poId,
            poSAPID: this.props.location.state.poSAPId,
            InvoiceId: this.props.location.state.InvoiceId,
            InvoiceStatusId: this.props.location.state.InvoiceStatusId,
            PoAmount: this.props.location.state.PoAmount,
            selectedFile: [],
            modal: false,
            paymentMethod: [],
            InvoiceDate: "",
            DueDate: "",
            InvoiceNo: "",
            InvoiceAmount: 0,
            ApprovedAmount: "",
            DocumentTypeId: "",
            DocumentTypeName: "",
            selectedpaymentmethod: "",
            approvalStatus: {
                approved: 1,
                rejected: 2,
                revise: 3
            },
            docStatus: {
                1: { title: "Document is Approved", badge: "badge-success", status: "Approved" },
                2: { title: "Document is Rejected", badge: "badge-danger", status: "Rejected" },
                3: { title: "Document sent for Revision", badge: "badge-primary", status: "Sent for Revision" },
                0: { title: "Document Uploaded", badge: "badge-warning", status: "" },
                6: { title: "Document Sent For Approval", badge: "badge-warning", status: "" },
                null: { title: "Document to be Submitted", badge: "badge-warning", status: "" },

            },
            isEligibleForAdvancePayment: 1,
            advanceAmount: 0,
            selectedFile: [],
            files: {},
            WBSNo: "",
            currency: "",
            ExchangeRate: 1,
            INRInvoiceAmount: 0,
            reviseForm: {
                file: [],
                comment: ""
            },
            revisedPayload: [],
            showRevisedPopUp: false,
            versionList: [],
            selectedFileVersion: [],
            selectedfilestageIdVersion: [],
            stageIdsVersion: [],
            fileUploadIds: [],
            uploadedId: "",
            uploadedfile: false,
            OpenVersionmodal: false,
            DocumentCommentsByDocumentIdPopUpModal: false,
            varId: "",
            varPoId: "",
            varPoLineId: "",
            vardocumentTypeId: "",
            vardrawingDocumentDetailId: "",
            TransmittalDocStatus: {
                0: { title: "Document Submitted", badge: "badge-warning", status: "" },
                1: { title: "Read", badge: "badge-success", status: "Read" },
            },
            transmittleDocumentName: '',
            addDocumentmodal: false,
            PoAnnexure: [],
            DrawingTransmittal: [],
            transmittalFile: [],
            flagR: 0,
            POCommentPopUpModal: false,
            // varPId : "",
            varDocumentId: "",
            paymentTermDocuments: [],
            activeEventKey: "10",
            approvalDetailsByCPMorTPM: [],
            dataFull: [],
            indicator: "",
            AcceptmodalForSupplier: false,
            dataFullForSupplier: [],
            InvoiceDocumentId: "",
            invoiceDetails: [],
            checkedSwitch: false,
            switchValue: 0,
            checkedSwitchByApTeam: 0,
            paymentTermDocumentsPartial: [],
            approvalDetailsByCPMorTPMPartial: [],
            AcceptmodalForSupplierPartial: false,
            AcceptmodalPartial: false,
            paymentTermPartialDetails: {},
            AdvanceStageDocumentMappingIdPartial: "",
            claimedExpeditorId: 0,
            claimedExpeditor: "",
            GRNbyPOId: [],
            GRNDocNo: "",
            GRNModal: false,
            GRNTableData: [],
            InvoiceIdForGRN: 0,
            GRNDropDownData: [],
            infoValGRN: 0,
            AdditionalEmailId: '',
            BGModal: false,
            newRecord: {},
            errors: {},
            BGupload: "",
            partialFlag: "",
            addAndUpdateBGModal: false,
            readOnlyValue: false,
            addUpdateBGModalData: {},
            bgModalData: {},
            selectedCurrency: "",
            SelectCurrencyArray: [],
            loading: false
        }
        this.Acceptmodal = this.Acceptmodal.bind(this);
        this.AcceptmodalForSupplier = this.AcceptmodalForSupplier.bind(this);
        this.togglebutton = this.togglebutton.bind(this);
        this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
        this.CancelPOAcceptanceModal = this.CancelPOAcceptanceModal.bind(this);
        this.ReviseModalPopUp = this.ReviseModalPopUp.bind(this);
        this.modal = this.modal.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.UploadPOAcceptanceModal = this.UploadPOAcceptanceModal.bind(this)
        this.UploadAcknowledgementModal = this.UploadAcknowledgementModal.bind(this)
        this.dataSync = this.dataSync.bind(this)
        this.refreshPage = this.refreshPage.bind(this)
        this.handleApproval = this.handleApproval.bind(this)
        this.DocumentCommentsByDocumentIdPopUpModal = this.DocumentCommentsByDocumentIdPopUpModal.bind(this);
        this.POCommentPopUpModal = this.POCommentPopUpModal.bind(this);
        this.AcceptmodalPartial = this.AcceptmodalPartial.bind(this);
        this.AcceptmodalForSupplierPartial = this.AcceptmodalForSupplierPartial.bind(this);
        this.documentRef = React.createRef()
        this.documentRef.current = []
    }
    ReviseModalPopUp(flagRevise = 0) {
        let flagR = flagRevise
        this.setState({ ReviseModal: !this.state.ReviseModal, flagR });
    }
    handleFileInput(event, rowData) {
        console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 170 ~ Dashboard ~ handleFileInput ~ rowData", rowData)
        console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 170 ~ Dashboard ~ handleFileInput ~ event", event)
        // console.log(event, rowData, "file input")
        this.setState({ selectedFile: [], files: [] })
        let fileList = [...this.state.selectedFile];
        let fileObjList = this.state.files
        fileObjList[rowData.DocumentTypeId] = {   //?????????????????????
            fileInfo: event.target.files[0],
            dataForFile: rowData
        }
        fileList.push(event.target.files[0])
        this.setState({ selectedFile: fileList, files: fileObjList })
        console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 176 ~ Dashboard ~ handleFileInput ~ fileList", this.state.selectedFile, this.state.files)
    }

    // ? handle file upload for PO Details Document
    onclickUpload = async (data, flag = 0, flagBG = 0, indicator = '') => {
        // console.log("data-partial",data)
        // return false
        // await this.setState({ loading: true })
        let comments = ""
        var documentId = 0
        var userID = AuthHandler.getUserID()
        if (data.DocumentId !== null) {
            documentId = data.DocumentId
        }
        if (this.state.selectedFile.length < 1) {
            swal("Please upload some valid document", { icon: "error" })
            return false;
        }
        console.log("uploadID", data, documentId, this.state.files[data.DocumentTypeId].fileInfo, this.state.InvoiceAmount)
        // return false;

        if (documentId != 0) {
            console.log("Enteeeeerrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
            toast.loading('Uploading Files...', {
                duration: 1000
            });
            await this.props.GenericUploadVersionFile([this.state.files[data.DocumentTypeId].fileInfo], documentId, comments, AuthHandler.getUserID());
        } else {
            // swal("Document is uploading...",{button:false,icon:"info"})
            toast.loading('Uploading Files...', {
                duration: 1000
            });
            var para = this.state.files[data.DocumentTypeId].fileInfo
            console.log("para", para)
            if (data.DocumentTypeId == 84 || data.DocumentTypeId == 73 || data.DocumentTypeId == 52 || data.DocumentTypeId == 36 || data.DocumentTypeId == 41 || data.DocumentTypeId == 46 || data.DocumentTypeId == 101 || data.DocumentTypeId == 110 || data.DocumentTypeId == 111 || data.DocumentTypeId == 112 || data.DocumentTypeId == 113 || data.DocumentTypeId == 114 || data.DocumentTypeId == 115 || data.DocumentTypeId == 118 || data.DocumentTypeId == 119) {
                var result = await this.props.uploadFileGeneric([this.state.files[data.DocumentTypeId].fileInfo], AuthHandler.getUserID(), data.PaymentTypeId)
            } else {
                var result = await this.props.uploadFileGeneric([this.state.files[data.DocumentTypeId].fileInfo], AuthHandler.getUserID())
            }
            console.log("result", result.results)
            console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 203 ~ Dashboard ~ onclickUpload=async ~ userID", userID)
            documentId = result.results[0].DocumentId
        }
        var params = {
            documentId: documentId,
            POId: this.state.poID,
            documentTypeId: data.DocumentTypeId,
            isSubmitted: 1,
            UploadedBy: userID,
            TypeForElem: data.TypeFor,
            ActedGroupId: data.ActingDeptGroupId,
            AdvanceStageDocumentMappingId: data.AdvanceStageDocumentMappingId ? data.AdvanceStageDocumentMappingId : 0,
            PaymentTypeId: indicator == 'Draft Documents' ? 4 : data.PaymentTypeId,
            approvalStatus: data.AdvanceStageDocumentMappingId ? data.approvalStatus == 0 ? 0 : 6 : 0,
            InvoiceId: data.InvoiceId
        }
        var input = {
            POSAPId: this.state.poSAPID,
            InvoiceNo: this.state.InvoiceNo,
            InvoiceDate: this.state.InvoiceDate,
            InvoiceAmount: this.state.InvoiceAmount,
            WBSNo: this.props.poDetails.paymentTermDetailsByPoId.wbsCode,
            CurrencyType: this.props.poDetails.paymentTermDetailsByPoId.Currency,
            PaymentTypeId: data.PaymentTypeId ? data.PaymentTypeId : 0,
            TypeFor: data.TypeFor ? data.TypeFor : "",
            InvoiceDocId: documentId,
            IsPartial: this.state.switchValue,
            InvoiceId: data.InvoiceId
        };
        await this.props.postMapAdvanceDocumentIDsToPO(params)
        if (flagBG == 1) {
            console.log(this.state.BGupload, "sdkjbhsdbkhdsb")
            if(this.state.BGupload.BGListDetailsId){
                let obj = { ...this.state.bgModalData, ["poId"]: this.state.poID,  ["TypeFor"]: this.state.BGupload.TypeFor, ["BGDocId"]: documentId }
                await this.props.postBGListDetails(obj)
            }
            else{
                let obj = { ...this.state.newRecord, ["poId"]: this.state.poID,  ["TypeFor"]: this.state.BGupload.TypeFor, ["BGDocId"]: documentId }
                await this.props.postBGListDetails(obj)
            }
            await this.BGModal()
            await this.setState({ newRecord: {} })
        }
        if (flag == 1) {
            await this.props.InsertInvoiceDetails(input)
        }
        toast.success('Uploaded Successfully', {
            duration: 1000
        });
        this.documentRef.current[data.DocumentTypeId].value = ""
        await this.dataSync()
        await this.setState({ loading: false, selectedFile: [], files: [] })
        // await this.props.getPOPurchaseOrders();
        // await this.props.GetDocumentsForAdvance(1);

        // await this.props.uploadFileforPOAcceptanceAdvance(this.state.selectedFile,uploadID);
    }
    // ? handle file upload for PO Details Document
    onclickUploadPartial = async (data, flag = 0, flagBG = 0) => {
        // console.log("data-partial",data)
        // return false
        await this.setState({ loading: true })
        let comments = ""
        var documentId = 0
        var userID = AuthHandler.getUserID()
        if (data.DocumentId == null) {
            if (this.state.selectedFile.length < 1) {
                await this.setState({ loading: false })
                swal("Please upload some valid document", { icon: "error" })
                return false;
            }
            // swal("Document is uploading...",{button:false,icon:"info"})
            toast.loading('Uploading Files...', {
                duration: 1000
            });
            var para = this.state.files[data.DocumentTypeId].fileInfo
            console.log("para", para)
            var result = await this.props.uploadFileGeneric([this.state.files[data.DocumentTypeId].fileInfo], AuthHandler.getUserID())
            console.log("result", result.results)
            console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 203 ~ Dashboard ~ onclickUpload=async ~ userID", userID)
            documentId = result.results[0].DocumentId
        }
        else {
            await this.props.GenericUploadVersionFile([this.state.files[data.DocumentTypeId].fileInfo], data.DocumentId, comments, AuthHandler.getUserID());
            documentId = data.DocumentId
        }
        var params = {
            documentId: documentId,
            AdvanceStageDocumentMappingId: data.AdvanceStageDocumentMappingIdPartial,
        }
        var input = {
            POSAPId: this.state.poSAPID,
            InvoiceNo: this.state.InvoiceNo,
            InvoiceDate: this.state.InvoiceDate,
            InvoiceAmount: this.state.InvoiceAmount,
            WBSNo: this.props.poDetails.paymentTermDetailsByPoId.wbsCode,
            CurrencyType: this.props.poDetails.paymentTermDetailsByPoId.Currency,
            PaymentTypeId: data.PaymentType ? data.PaymentType : 0,
            TypeFor: data.TypeFor ? data.TypeFor : "",
            InvoiceDocId: documentId,
            IsPartial: this.state.switchValue
        };
        await this.props.UpdatePartialPaymentDetails(params)
        if (flagBG == 1) {
            let obj = { ...this.state.newRecord, ["poId"]: this.state.poID, ["TypeFor"]: this.state.BGupload.TypeFor, ["BGDocId"]: documentId }
            await this.props.postBGListDetails(obj)
            await this.BGModal()
            await this.setState({ newRecord: {} })
        }
        if (flag == 1) {
            await this.props.InsertInvoiceDetails(input)
        }
        await this.dataSync()
    }
    async modalSubmit() {
        let array = []
        let temp = {
            invoiceId: this.state.InvoiceId,
            paymentMediumId: this.state.selectedpaymentmethod
        }
        array.push(temp)
        await this.props.setInvoicePaymentMedium({
            invoiceIdVsPaymentMedium: array
        })
        this.modal()
    }

    modal() {
        this.setState({ modal: !this.state.modal });

        if (this.state.modal == true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )

        }
    }

    // ? for revise action
    revisePopUpAction = (reviseParam, popUpStatus, refreshPage, uploadId, actionstatus) => {
        console.log(reviseParam, popUpStatus, refreshPage, uploadId, actionstatus, "reviseParam")
        this.setState({ revisedPayload: reviseParam, showRevisedPopUp: popUpStatus, uploadID: uploadId, actionstatus });
        if (refreshPage) {
            this.dataSync()
        }
    }


    handleFileInputforRevision = (event) => {
        let fileList = [];
        fileList.push(event.target.files[0])
        let reviseForm = this.state.reviseForm
        reviseForm.file = fileList

        let selectedfilestageIdVersion = [this.state.revisedPayload.param.documentTypeId]
        let stageIdsVersion = [this.state.revisedPayload.param.stageDocumentId];
        let fileUploadIds = [this.state.revisedPayload.param.uploadId]
        this.setState({
            reviseForm,
            selectedfilestageIdVersion,
            stageIdsVersion,
            fileUploadIds
        });
    }

    formChange = (e) => {
        console.log("Event", e.target.value);
        let reviseForm = this.state.reviseForm
        reviseForm.comment = e.target.value;
        this.setState({ reviseForm });
    }


    formSaveAction = async (flag) => {
        // console.log(this.state.revisedPayload,"this.state.revisedPayload.param")
        // return false
        if (this.state.revisedPayload.actionType == "Supplier Documents partial") {
            if (this.state.reviseForm.file.length < 1 && this.state.reviseForm.comment == "") {
                if (this.state.actionstatus == 1) {
                    await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.approved, this.state.revisedPayload.param, this.state.invoiceDetails, this.props.poDetails.paymentTermDetailsByPoId.poId)
                }
                else { await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.revise, this.state.revisedPayload.param, this.state.invoiceDetails, this.props.poDetails.paymentTermDetailsByPoId.poId) }
                await this.revisePopUpAction(false);
            }
            else {
                // only comment
                if (this.state.reviseForm.file.length < 1) {

                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandler.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandler.getGroups())[0]),
                        UserId: AuthHandler.getUserID(),
                        DocumentId: this.state.uploadID,
                        PoId: this.props.poDetails.paymentTermDetailsByPoId.poId,
                        PoLineItemId: 0,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    if (this.state.actionstatus == 1) {
                        await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.approved, this.state.revisedPayload.param, this.state.invoiceDetails, this.props.poDetails.paymentTermDetailsByPoId.poId)

                    }
                    else { await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.revise, this.state.revisedPayload.param, this.state.invoiceDetails, this.props.poDetails.paymentTermDetailsByPoId.poId) }
                    await this.revisePopUpAction(false);
                }
                //only file
                else {
                    console.log(this.state.revisedPayload, 'payload')

                    // swal("Saving...", { icon: "info", button: false });
                    let comments = [this.state.reviseForm.comment];
                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandler.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandler.getGroups())[0]),
                        UserId: AuthHandler.getUserID(),
                        DocumentId: this.state.revisedPayload.param.DocumentId,
                        PoId: this.props.poDetails.paymentTermDetailsByPoId.poId,
                        PoLineItemId: 0,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, comments, AuthHandler.getUserID());
                    if (this.state.actionstatus == 1) {
                        await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.approved, this.state.revisedPayload.param, this.state.invoiceDetails, this.props.poDetails.paymentTermDetailsByPoId.poId)
                    }
                    else {
                        await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.revise, this.state.revisedPayload.param, this.state.invoiceDetails, this.props.poDetails.paymentTermDetailsByPoId.poId)
                    }
                }
                let reviseForm = {
                    comment: "",
                    file: ""
                }
                await this.revisePopUpAction(false);
                await this.setState({ reviseForm })
            }
        } else {
            console.log(this.state.reviseForm.file, "______________")
            //no comment no file
            if (this.state.reviseForm.file.length < 1 && this.state.reviseForm.comment == "") {
                if (this.state.actionstatus == 1) {
                    await this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.approved, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['1'].status, this.state.revisedPayload.param)
                }
                else { await this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.revise, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['3'].status, this.state.revisedPayload.param) }
                await this.revisePopUpAction(false);
            }
            else {
                // only comment
                if (this.state.reviseForm.file.length < 1) {

                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandler.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandler.getGroups())[0]),
                        UserId: AuthHandler.getUserID(),
                        DocumentId: this.state.uploadID,
                        PoId: this.props.poDetails.paymentTermDetailsByPoId.poId,
                        PoLineItemId: 0,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    if (this.state.actionstatus == 1) {
                        await this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.approved, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['1'].status, this.state.revisedPayload.param)

                    }
                    else { await this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.revise, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['3'].status, this.state.revisedPayload.param) }
                    await this.revisePopUpAction(false);
                }
                //only file
                else {
                    console.log(this.state.revisedPayload, 'payload')

                    // swal("Saving...", { icon: "info", button: false });
                    let comments = [this.state.reviseForm.comment];
                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandler.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandler.getGroups())[0]),
                        UserId: AuthHandler.getUserID(),
                        DocumentId: this.state.revisedPayload.param.DocumentId,
                        PoId: this.props.poDetails.paymentTermDetailsByPoId.poId,
                        PoLineItemId: 0,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, comments, AuthHandler.getUserID());
                    if (this.state.actionstatus == 1) {
                        await this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.approved, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['1'].status, this.state.revisedPayload.param)

                    }
                    else {
                        await this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.revise, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['3'].status, this.state.revisedPayload.param)
                    }
                }
                let reviseForm = {
                    comment: "",
                    file: ""
                }
                await this.revisePopUpAction(false);
                await this.setState({ reviseForm })
            }
        }
        await this.dataSync()
    }


    refreshPage() {
        window.location.reload(false);
    }

    // Change document approval status
    handleApproval = async (poId, documentTypeId, approvalStatus, documentName, documentStatus, dataFull, invoiceDetails) => {
        await this.setState({ loading: true })
        // console.log(approvalStatus,this.state.uploadID, "Input BY AP Team")
        // return false
        var roles = authInstance.getRoles();
        var groups = authInstance.getGroups();
        // console.log( "{{{{{{{",dataFull,this.state.revisedPayload.param)
        // return false
        if (roles[8] == true && groups[8] == true && approvalStatus == 1 && (documentTypeId == 36 || documentTypeId == 41 || documentTypeId == 46 || documentTypeId == 52 || documentTypeId == 73 || documentTypeId == 84 || documentTypeId == 101 || documentTypeId == 110 || documentTypeId == 111 || documentTypeId == 112 || documentTypeId == 113 || documentTypeId == 114 || documentTypeId == 115 || documentTypeId == 118 || documentTypeId == 119)) {
            if (this.state.InvoiceDate == '' && this.state.DueDate == '') {
                await this.setState({ loading: false })
                swal("Please enter value in Date Field", { button: true, icon: "error" })
                return false
            }
            var input = {
                POSAPId: this.state.poSAPID,
                InvoiceNo: this.state.InvoiceNo ? this.state.InvoiceNo : this.state.invoiceDetails[0].InvoiceNo,
                InvoiceDate: this.state.InvoiceDate ? this.state.InvoiceDate : this.state.invoiceDetails[0].InvoiceDate,
                PayableAmount: this.state.ApprovedAmount,
                DueDate: this.state.DueDate,
                InvoiceAmount: this.state.InvoiceAmount ? this.state.InvoiceAmount : this.state.invoiceDetails[0].InvoiceAmount,
                WBSNo: this.props.poDetails.paymentTermDetailsByPoId.wbsCode,
                CurrencyType: this.props.poDetails.paymentTermDetailsByPoId.Currency,
                InvoiceAmountinINR: this.state.INRInvoiceAmount ? this.state.INRInvoiceAmount : this.state.InvoiceAmount,
                PaymentTypeId: dataFull.PaymentTypeId ? dataFull.PaymentTypeId : 0,
                TypeFor: dataFull.TypeFor ? dataFull.TypeFor : "",
                exchangeRate: this.state.ExchangeRate ? this.state.ExchangeRate : 1,
                InvoiceDocId: this.state.InvoiceDocumentId,
                Indicator: 1,
                IsPartial: this.state.checkedSwitchByApTeam == 0 && invoiceDetails.find(data => data.InvoiceDocId == this.state.InvoiceDocumentId).IsPartial != 0 ? 2 : this.state.switchValue
            };
            // console.log(input,"Input BY AP Team")
            // return false
            if (approvalStatus == 1) {
                await this.Acceptmodal();
            }
            await this.props.InsertInvoiceDetails(input)
            console.log(input, "Selected Values::");
            const approveBy = parseInt(AuthHandler.getUserID())
            const userName = AuthHandler.getUserPayLoad()
            // console.log(dataFull,"FGFHFGFHFGFHFGF")
            // return false
            await this.props.postUpdateAdvanceDocumentStatus(
                dataFull.AdvanceStageDocumentMappingId,
                dataFull.ActingDeptGroupId,
                poId,
                documentTypeId,
                approvalStatus,
                approveBy,
                userName.fullName,
                new Date(),
                dataFull.PaymentTypeId ? dataFull.PaymentTypeId : 0,
                dataFull.TypeFor ? dataFull.TypeFor : "",
                this.state.uploadID
            )
            await this.dataSync()
            return false
        }
        if (this.state.Acceptmodal == true) {
            await this.Acceptmodal();
        }

        // ? getting the userId for approvedBy
        const approveBy = parseInt(AuthHandler.getUserID())
        const userName = AuthHandler.getUserPayLoad()
        console.log("🚀 ~ file: Advanced-PoAcceptanceTrail.js ~ line 194 ~ PoAcceptanceTrail ~ handleApproval=async ~ userName", userName)

        // ? toast alert
        toast.loading(`${documentStatus} Document : ${documentName}...`, {
            duration: 1000
        });
        // ? calling store to update Advance Document Status
        await this.props.postUpdateAdvanceDocumentStatus(
            dataFull.AdvanceStageDocumentMappingId,
            dataFull.ActingDeptGroupId,
            poId,
            documentTypeId,
            approvalStatus,
            approveBy,
            userName.fullName,
            new Date(),
            dataFull.PaymentTypeId,
            dataFull.TypeFor,
            this.state.uploadID
        )
        toast.success(`Document ${documentName} ${documentStatus}!`, {
            duration: 6000
        });
        await this.dataSync()

    }
    handleApprovalPartial = async (AdvanceStageDocumentMappingIdPartial, approvalStatus, dataFull, invoiceDetails, poId = 0) => {
        console.log(":Lkjhgcvds", this.state.approvalStatus.approved, approvalStatus)
        // return false
        await this.setState({ loading: true })
        var roles = authInstance.getRoles();
        var groups = authInstance.getGroups();
        if (roles[8] == true && groups[8] == true && approvalStatus === this.state.approvalStatus.approved && (dataFull.DocumentTypeId == 36 || dataFull.DocumentTypeId == 41 || dataFull.DocumentTypeId == 46 || dataFull.DocumentTypeId == 52 || dataFull.DocumentTypeId == 73 || dataFull.DocumentTypeId == 84 || dataFull.DocumentTypeId == 101 || dataFull.DocumentTypeId == 110 || dataFull.DocumentTypeId == 111 || dataFull.DocumentTypeId == 112 || dataFull.DocumentTypeId == 113 || dataFull.DocumentTypeId == 114 || dataFull.DocumentTypeId == 115 || dataFull.DocumentTypeId == 118 || dataFull.DocumentTypeId == 119)) {
            console.log(this.state.InvoiceDate, this.state.invoiceDetails, this.state.DueDate, approvalStatus, "sdfbskhdbfksd")
            if (this.state.InvoiceDate == '' && this.state.DueDate == '') {
                await this.setState({ loading: false })
                swal("Please enter value in Date Field", { button: true, icon: "error" })
                return false
            }
            var input = {
                POSAPId: this.state.poSAPID,
                InvoiceNo: this.state.InvoiceNo ? this.state.InvoiceNo : this.state.invoiceDetails[0].InvoiceNo,
                InvoiceDate: this.state.InvoiceDate ? this.state.InvoiceDate : this.state.invoiceDetails[0].InvoiceDate,
                PayableAmount: this.state.ApprovedAmount,
                DueDate: this.state.DueDate,
                InvoiceAmount: this.state.InvoiceAmount ? this.state.InvoiceAmount : this.state.invoiceDetails[0].InvoiceAmount,
                WBSNo: this.props.poDetails.paymentTermDetailsByPoId.wbsCode,
                CurrencyType: this.props.poDetails.paymentTermDetailsByPoId.Currency,
                InvoiceAmountinINR: this.state.INRInvoiceAmount ? this.state.INRInvoiceAmount : this.state.InvoiceAmount,
                PaymentTypeId: dataFull.PaymentType ? dataFull.PaymentType : 0,
                TypeFor: dataFull.TypeFor ? dataFull.TypeFor : "",
                exchangeRate: this.state.ExchangeRate ? this.state.ExchangeRate : 1,
                InvoiceDocId: parseInt(this.state.InvoiceDocumentId),
                Indicator: 1,
                IsPartial: this.state.checkedSwitchByApTeam == 0 && invoiceDetails.find(data => data.InvoiceDocId == this.state.InvoiceDocumentId).IsPartial != 0 ? 2 : this.state.switchValue
            };
            console.log(input, dataFull, "Input BY AP Team")
            // return false
            await this.props.InsertInvoiceDetails(input)
            console.log(input, "Selected Values::");
            if (approvalStatus == 1) {
                await this.AcceptmodalPartial();
            }
            const approveBy = parseInt(AuthHandler.getUserID())
            const userName = AuthHandler.getUserPayLoad()
            var params = {
                AdvanceStageDocumentMappingIdPartial: AdvanceStageDocumentMappingIdPartial,
                approvalStatus: approvalStatus,
                approvedBy: approveBy,
                approvedByName: userName.fullName,
                approvedOn: new Date(),
                ActedGroupId: dataFull.ActingDeptGroupId,
                DocumentTypeName: dataFull.DocumentTypeName,
                documentTypeId: dataFull.DocumentTypeId
            }
            await this.props.UpdateApprovalForAdvanceDocumentPartial(params, poId)
            await this.dataSync()
            return false
        }

        // ? getting the userId for approvedBy
        const approveBy = parseInt(AuthHandler.getUserID())
        const userName = AuthHandler.getUserPayLoad()
        console.log("🚀 ~ file: Advanced-PoAcceptanceTrail.js ~ line 194 ~ PoAcceptanceTrail ~ handleApproval=async ~ userName", userName)

        // ? toast alert
        toast.loading(`Processing...`, {
            duration: 1000
        });
        // ? calling store to update Advance Document Status
        var params = {
            AdvanceStageDocumentMappingIdPartial: AdvanceStageDocumentMappingIdPartial,
            approvalStatus: approvalStatus,
            approvedBy: approveBy,
            approvedByName: userName.fullName,
            approvedOn: new Date(),
            ActedGroupId: dataFull.ActingDeptGroupId,
            documentTypeId: dataFull.DocumentTypeId
        }
        await this.props.UpdateApprovalForAdvanceDocumentPartial(params, poId = 0)
        toast.success(`Approved`, {
            duration: 6000
        });
        await this.dataSync()

    }
    Acceptmodal = async (DocumentTypeId, DocumentTypeName, dataFull, InvoiceDocumentId) => {
        await this.props.GetInvoiceDetailsForAPteamApproval(InvoiceDocumentId)
        let invoiceDetails = await this.props.invoices.getAllInvoicesforApTeamApproval.recordset
        console.log(InvoiceDocumentId, invoiceDetails, "DatFull")
        await this.setState({ DocumentTypeId, DocumentTypeName, dataFull, InvoiceDocumentId, invoiceDetails, Acceptmodal: !this.state.Acceptmodal });
    }
    AcceptmodalForSupplier(dataFullForSupplier) {
        console.log(dataFullForSupplier, 'dataFullForSupplier')
        let InvAmt = this.state.InvoiceAmount ? this.state.InvoiceAmount : dataFullForSupplier && dataFullForSupplier.InvoiceAmount ? dataFullForSupplier.InvoiceAmount : 0
        let InvoiceDate = this.state.InvoiceDate ? this.state.InvoiceDate : dataFullForSupplier && dataFullForSupplier.InvoiceDate ? formatDate(dataFullForSupplier.InvoiceDate) : ""
        let InvoiceNo = this.state.InvoiceNo ? this.state.InvoiceNo : dataFullForSupplier && dataFullForSupplier.InvoiceNo ? dataFullForSupplier.InvoiceNo : ""
        // if (dataFullForSupplier.PaymentTypeId == 3) {
        //     InvAmt = dataFullForSupplier.InvoiceAmount
        // }
        this.setState({ AcceptmodalForSupplier: !this.state.AcceptmodalForSupplier, dataFullForSupplier, InvoiceAmount: InvAmt, InvoiceDate, InvoiceNo });
        if (this.state.AcceptmodalForSupplier == true) {
            this.setState({ opacity: "" });
        } else {
            this.setState({ opacity: "0.2" });
        }
    }
    GRNModal() {
        this.setState({ GRNModal: !this.state.GRNModal });
        if (this.state.GRNModal == true) {
            this.setState({ opacity: "" });
        } else {
            this.setState({ opacity: "0.2" });
        }
    }
    AcceptmodalPartial = async (AdvanceStageDocumentMappingIdPartial, dataFull, InvoiceDocumentId) => {
        await this.props.GetInvoiceDetailsForAPteamApproval(InvoiceDocumentId)
        let invoiceDetails = await this.props.invoices.getAllInvoicesforApTeamApproval.recordset
        console.log(InvoiceDocumentId, invoiceDetails, "DatFull")
        await this.setState({ AdvanceStageDocumentMappingIdPartial, dataFull, InvoiceDocumentId, invoiceDetails, AcceptmodalPartial: !this.state.AcceptmodalPartial });
    }
    AcceptmodalForSupplierPartial(dataFullForSupplier) {
        this.setState({ AcceptmodalForSupplierPartial: !this.state.AcceptmodalForSupplierPartial });
        if (this.state.AcceptmodalForSupplierPartial == true) {
            this.setState({ opacity: "" });
        } else {
            this.setState({ opacity: "0.2", dataFullForSupplier });
        }
    }

    toggleReviseModal(e) {
        this.setState({ ReviseModal: e });
        if (this.state.ReviseModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    CancelPOAcceptanceModal() {
        this.setState({ CancelPOAcceptanceModal: !this.state.CancelPOAcceptanceModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.CancelPOAcceptanceModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    requestBGRequest = async (element) => {
          toast.loading('Requesting...', {
            duration: 1000
          });
          await this.props.UpdateBGStatusforBGRequestRequest({BGListDetailsId: element.BGListDetailsId, BGRequestStatus: 6, BGType: element.TypeFor, userId: AuthHandler.getUserID(), Comments: "BG_Request_Submitted", action: "BG_Request_Submission", username:  AuthHandler.getUserPayLoad().fullName, activityId: (element.TypeFor == 'ABG'? 88 : 89)});
        await this.dataSync()
      }

         
    async OpenInFoModal (item) {
        console.log(item, "this.state.uploadID")
        await this.props.getactionDetail(item)
        console.log(this.props.expediting, "sdkhfbkhsdbfkbdskjfbksbdf")

        if(this.props.expediting && this.props.expediting.bgRequestacton){
            let stateVal = this.state.OpenInFoModal;
            this.setState({ OpenInFoModal: !stateVal, selectedBGRow: item });
        }
        else{
            toast.error(`Something went wrong, Please try again`, {
                duration: 1000
            });
            await this.dataSync()
            return false;
        }
       
    }

    toggleCancelPOAcceptanceModal(e) {
        this.setState({ CancelPOAcceptanceModal: !this.state.CancelPOAcceptanceModal });
        if (this.state.CancelPOAcceptanceModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    approvePOAcceptanceDocument(poId, statusId, isWaivedOff = 0) {
        this.props.postApprovePOAcceptance({
            POId: poId,
            statusId: statusId,
            UserId: authInstance.getUserID(),
            isWaivedOff: isWaivedOff
        })
        if (isWaivedOff == 0) {
            swal("Approved", { button: true, icon: "success" }).then((truth) => {
                this.refreshPage()
            })
        } else {
            swal("Waived Off", { button: true, icon: "success" }).then((truth) => {
                this.refreshPage()
            })
        }
    }

    UploadPOAcceptanceModal() {
        this.setState({ UploadPOAcceptanceModal: !this.state.UploadPOAcceptanceModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.UploadPOAcceptanceModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleUploadPOAcceptanceModal(e) {
        this.setState({ UploadPOAcceptanceModal: !this.state.UploadPOAcceptanceModal });
        if (this.state.UploadPOAcceptanceModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    UploadAcknowledgementModal() {
        this.setState({ UploadAcknowledgementModal: !this.state.UploadAcknowledgementModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.UploadAcknowledgementModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleUploadAcknowledgementModal(e) {
        this.setState({ UploadAcknowledgementModal: !this.state.UploadAcknowledgementModal });
        if (this.state.UploadAcknowledgementModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    approvalUi(element) {
        return (
            <>
                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.changeDocStatus(3, element.uploadId)} />
                {/* <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"times-circle"} color={"red"} title="Reject" size="2x" onClick={() => this.rejectPopUpAction({ actionType: "Supplier Documents", param: element }, true)} /> */}
                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: element }, true)/*()=>this.changeDocStatus(5,el.uploadId)*/} />
            </>
        )
    }

    handleSingleCheckboxChange = index => {
        console.log(index);

        var checkedCopy = this.state.checked;
        checkedCopy[index] = !this.state.checked[index];
        if (checkedCopy[index] === false) {
            this.setState({ selectAll: false });
        }

        this.setState({
            checked: checkedCopy
        });
    };

    togglebutton = (Index) => {
        var multiCollapseIndex = this.state.multiCollapseIndex
        if (multiCollapseIndex != Index || multiCollapseIndex == '') {
            this.setState({ multiCollapseIndex: Index })
        }
    }


    dataSync = async () => {
        await this.props.GetPaymentTermDetailByPOId(this.state.poID)
        await this.props.GetDraftDocuments(this.state.poID)
        await this.props.GetDocumentsForAdvance(this.state.poID)
        await this.props.getallMasterData()
        await this.props.GetClaimDetailsByPoId(this.state.poID)
        await this.props.GetPaymentTermDetails(this.props.poDetails.paymentTermDetailsByPoId.paymentTermId)
        await this.props.getPaymentTermDocuments(this.state.poID)
        await this.props.GetAllCurrencyDetails()
        await this.props.GetTransmittalDocumentDetails()
        await this.props.GetGRNDetails(this.state.poID)
        await this.props.GetBgDraftDocTableData(AuthHandler.getUserID(), AuthHandler.getGroups())
        await this.props.PaymentTermDocumentsApprovalByPMs(this.state.poID)
        await this.props.postAdditionalEmailId({ VendorEmail: this.props.poDetails.paymentTermDetailsByPoId.vendorEmail })
        let AdditionalEmailId = this.props.poDetails && this.props.poDetails.additionalEmailId && this.props.poDetails.additionalEmailId.length > 0 ? this.props.poDetails.additionalEmailId[0].EmailId : ''
        let claimedExpeditorId = await this.props.expediting.getClaimDetailsByPoId.recordset[0].UserId
        let claimedExpeditor = await this.props.expediting.getClaimDetailsByPoId.recordset[0].ClaimBy
        let GRNbyPOId = await this.props.dispatchOrderDetailsReducer.getGRNdata.recordset
        let BgDraftDocTableData = await this.props.bgdraftDocReducer?.BGDocTable || null;
        let GRNDropDownData = []
        GRNbyPOId.map((data) => {
            if (data.GRNDocumentId == null && !GRNDropDownData.find(elem => elem.value == data.GRNDocNo && elem.GRNDocumentId == null)) {
                GRNDropDownData.push({ label: data.GRNDocNo, value: data.GRNDocNo })
            }
        })
        var approvalDetailsByCPMorTPM = []
        var approvalDetailsByCPMorTPMPartial = []
        try {
            if (this.props.poDetails && this.props.poDetails.paymentTermApprovalByCPMandTPM && this.props.poDetails.paymentTermApprovalByCPMandTPM.recordsets && this.props.poDetails.paymentTermApprovalByCPMandTPM.recordsets.length > 0) {
                approvalDetailsByCPMorTPM = await this.props.poDetails.paymentTermApprovalByCPMandTPM.recordset
                approvalDetailsByCPMorTPMPartial = await this.props.poDetails.paymentTermApprovalByCPMandTPM.recordsets[1]
                await this.setState({ approvalDetailsByCPMorTPM, approvalDetailsByCPMorTPMPartial, claimedExpeditorId, claimedExpeditor, GRNbyPOId, GRNDropDownData, AdditionalEmailId })
                console.log("PPPPPP", this.state.GRNbyPOId, this.state.approvalDetailsByCPMorTPM, approvalDetailsByCPMorTPMPartial)
            }

        } catch (e) { }
        var PoAnnexure = []
        var DrawingTransmittal = []
        console.log(this.props.expediting.getPoTransmittleDOcuments, "llllllllllll")
        try {
            if (this.props.expediting && this.props.expediting.getPoTransmittleDOcuments) {
                PoAnnexure = await this.props.expediting.getPoTransmittleDOcuments.filter((elem) => (elem.POId === 0 || elem.POId === this.state.poID) && elem.Indicator == 1)
                DrawingTransmittal = await this.props.expediting.getPoTransmittleDOcuments.filter((elem) => elem.POId === this.state.poID && elem.Indicator == 2)
                await this.setState({ PoAnnexure, DrawingTransmittal })
            }
        } catch (e) { }
        var paymentTermDocuments = []
        var paymentTermDocumentsPartial = []
        var paymentTermPartialDetails = {}
        let ConterData = []
        let GRNData = []
        let DraftDocuments = []
        // get the draft document details start
        await this.props.poDetails.DraftDocuments.recordset.map(elem => {
            if (!DraftDocuments.find(data => data.Counter === elem.Counter)) {
                DraftDocuments.push({
                    "Counter": elem.Counter,
                    "PaymentTypeId": 3,
                    "InvoiceId": elem.InvoiceId,
                    "TypeFor": null,
                    "isApproved": this.props.poDetails.DraftDocuments.recordset.find((data) => data.Counter == elem.Counter && data.approvalStatus !== 1) ? 0 : 1,
                    "Documents": this.props.poDetails.DraftDocuments.recordset.filter((data) => data.Counter == elem.Counter)
                })
            }
        })
        // get the draft document details end
        try {
            if (this.props.poDetails && this.props.poDetails.paymentTermDocuments && this.props.poDetails.paymentTermDocuments.recordsets && this.props.poDetails.paymentTermDocuments.recordsets.length > 0) {

                await this.props.poDetails.paymentTermDocuments.recordset.map((item) => {
                    if (!paymentTermDocuments.find(data => data.PaymentTypeId == item.PaymentTypeId && data.Amount == item.Amount && data.TypeFor == item.TypeFor
                        && (item.PaymentTypeId !== 3 || item.InvoiceId == data.InvoiceId))) {
                        if (item.PaymentTypeId == 3) {
                            GRNData = this.state.GRNbyPOId.filter(elem => elem.InvoiceId == item.InvoiceId)
                        }
                        let ApprovalDepartments = []
                        this.props.poDetails.paymentTermDocuments.recordset.filter(element => element.PaymentTypeId == item.PaymentTypeId && element.Amount == item.Amount && element.TypeFor == item.TypeFor && (item.PaymentTypeId !== 3 || item.InvoiceId == element.InvoiceId)).map(data => {
                            if (data.DocumentTypeId !== 40) { //to exclude order acceptance from approval matrix
                                if (ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId)) {
                                    // total Approval count
                                    ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount = ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount + 1

                                    if (data.approvalStatus == 1) { // total approved count
                                        ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount = ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount + 1
                                    }
                                } else {
                                    ApprovalDepartments.push({
                                        "ActingDeptGroupId": data.ActingDeptGroupId,
                                        "TotalApprovalCount": 1,
                                        "ShortDeptName": data.ShortDeptName,
                                        "ApprovedCount": data.approvalStatus == 1 ? 1 : 0
                                    })
                                }
                            }
                        })
                        paymentTermDocuments.push({
                            "PaymentTypeId": item.PaymentTypeId,
                            "PaymentType": item.PaymentTypeName,
                            "TypeFor": item.TypeFor,
                            "Counter": item.Counter,
                            "Summited_ON": item.Summited_ON,
                            "Amount": item.Amount,
                            "InvoiceId": item.InvoiceId,
                            "InvoiceAmount": item.InvoiceAmount,
                            "Currency": item.Currency,
                            "Documents": this.props.poDetails.paymentTermDocuments.recordset.filter(element =>
                                element.PaymentTypeId == item.PaymentTypeId && element.Amount == item.Amount && element.TypeFor == item.TypeFor && (item.PaymentTypeId !== 3 || item.InvoiceId == element.InvoiceId)
                            ),
                            "GRN": GRNData,
                            "ApprovalDepartments": ApprovalDepartments
                        })
                    }
                })
                if (this.props.poDetails.paymentTermDocuments.recordsets[2].length > 0) {
                    await this.props.poDetails.paymentTermDocuments.recordsets[1].map(async (item) => {
                        ConterData = this.props.poDetails.paymentTermDocuments.recordsets[2].filter(element =>
                            element.PaymentType == item.PaymentTypeId && element.Amount == item.Amount && element.TypeFor == item.TypeFor
                        )
                        ConterData.map(el => {
                            // console.log(el, "IIIIIIIII")
                            let ApprovalDepartments = []
                            this.props.poDetails.paymentTermDocuments.recordsets[3].filter(elem => elem.Counter == el.Counter && elem.TypeFor == item.TypeFor && elem.PaymentType == item.PaymentTypeId && elem.Amount == el.Amount).map(data => {
                                if (data.ActingDeptGroupId !== null && data.DocumentTypeId !== 40) { //to exclude order acceptance from approval matrix
                                    if (ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId)) {
                                        ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount = ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount + 1

                                        if (data.approvalStatus == 1) { // total approved count
                                            ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount = ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount + 1
                                        }
                                    } else {
                                        ApprovalDepartments.push({
                                            "ActingDeptGroupId": data.ActingDeptGroupId,
                                            "TotalApprovalCount": 1,
                                            "ShortDeptName": data.ShortDeptName,
                                            "ApprovedCount": data.approvalStatus == 1 ? 1 : 0
                                        })
                                    }
                                }
                            })
                            paymentTermDocumentsPartial.push({
                                "PaymentTypeId": item.PaymentTypeId,
                                "PaymentType": item.PaymentTypeName,
                                "TypeFor": item.TypeFor,
                                "Counter": el.Counter,
                                "Amount": item.Amount,
                                "PoId": el.PoId,
                                "Documents": this.props.poDetails.paymentTermDocuments.recordsets[3].filter(elem => elem.Counter == el.Counter && elem.TypeFor == item.TypeFor && elem.Amount == el.Amount && elem.PaymentType == item.PaymentTypeId),
                                "ApprovalDepartments": ApprovalDepartments
                            })
                        })
                        this.props.poDetails.paymentTermDocuments.recordsets[3].map(elem => {
                            paymentTermPartialDetails[elem.AdvanceStageDocumentMappingIdPartial] = elem
                        })
                    })
                }
                paymentTermDocuments.map(elem => {
                    elem.DraftDocumentApprovaStatus = DraftDocuments.find(data => data.Counter === elem.Counter && data.InvoiceId === elem.InvoiceId && data.isApproved === 1) ? 1 : 0
                })
                await this.setState({ paymentTermDocuments, BgDraftDocTableData, paymentTermDocumentsPartial, paymentTermPartialDetails, DraftDocuments })
                console.log("KLKLKLKLKLKLK", this.state.paymentTermDocuments, this.state.DraftDocuments)
            }
        } catch (e) { }
        await this.setState({
            InvoiceNo: '',
            InvoiceDate: '',
            ApprovedAmount: 0,
            DueDate: '',
            InvoiceAmount: 0,
            INRInvoiceAmount: 0,
            loading: false,
            ExchangeRate: 0,
            OpenInFoModal: false,
            selectedBGRow: {},
        })

        console.log("PPPPPP", this.state.paymentTermDocuments)
    }

    togglebutton = (Index) => {
        var multiCollapseIndex = this.state.multiCollapseIndex
        if (multiCollapseIndex != Index || multiCollapseIndex == '') {
            this.setState({ multiCollapseIndex: Index })
        }
    }
    componentDidMount = async () => {
        await this.setState({ loading: true })
        var role = Object.keys(authInstance.getRoles())[0]
        var UserId = authInstance.getUserID()
        if (role == 5) {
            await this.props.GetAllInvoicesForSupplier({ UserId: UserId })
        }
        await this.dataSync()
        await this.setState({ supplierName: mockData.VendorName })
    }
    handleDueDate = (event) => {
        this.setState({ DueDate: event.target.value });
    };

    handleInvoiceDate = async (event) => {
        const selectedDate = event.target.value;
        const currentDate = new Date().toISOString().split('T')[0]; 

        if (selectedDate <= currentDate) {
            await this.setState({ InvoiceDate: selectedDate });
        } else {
            await this.setState({ InvoiceDate: "" });
            swal("Selected date cannot be further than today's date", { icon: "error" })
            console.error("Selected date cannot be later than today's date");
        }
    };

    InvoiceNoInput = async (e) => {
        await this.setState({ InvoiceNo: e.target.value });
    };
    ApprovedAmountInput = (e) => {
        this.setState({ ApprovedAmount: e.target.value });
    };
    handleWBSNo = (e) => {
        this.setState({ WBSNo: e.target.value });
    };
    handlecurrency = (e) => {
        this.setState({ currency: e.target.value })
    }
    handleINRinvoiceAmount = (e) => {
        this.setState({ INRInvoiceAmount: e.target.value })
    }
    InvoiceAmountInput = async (value) => {
        console.log(value, 'value')
        await this.setState({ InvoiceAmount: value });
    };
    handleExchangeRate = async (value) => {
        let InvoiceAmount = this.state.InvoiceAmount
        let ExchangeRate = value
        let INRInvoiceAmount = parseFloat(InvoiceAmount) * parseFloat(ExchangeRate)
        await this.setState({ ExchangeRate, INRInvoiceAmount })
    }
    handleSelect = (e) => {
        this.setState({
            selectedpaymentmethod: e.target.value
        })
    }

    //For Treasury and All other Teams
    handlebudgetchange(e) {
        console.log(e.target.value)
        this.setState({ update_budget: e.target.value })
    }
    handlesavebudget() {
        console.log("budget=", this.state.budget, "updatebudget=", this.state.update_budget, "budgetamountId=", this.state.budgetamountId)
        var currDate = this.state.Curr_Day.split("/").reverse().join("-")
        var endDate = this.state.finalLastDay.split("/").reverse().join("-")
        console.log(currDate, endDate)
        this.props.insertbudgetamount({
            BudgetAmountId: this.state.budgetamountId,
            Amount: this.state.update_budget,
            StartDate: currDate,
            EndDate: endDate
        })
    }

    handlesendtofinance = async () => {
        var role = Object.keys(authInstance.getRoles())[0]
        var group = Object.keys(authInstance.getGroups())[0]

        if (role == 8 && group == 9) {
            await this.props.updateStatusForFinance(3, this.state.InvoiceId)
        }
        else if (role == 9 && group == 10) {
            await this.props.updateStatusForFinance(5, this.state.InvoiceId)
        }
        else if (role == 10 && group == 15) {
            await this.props.updateStatusForFinance(5, this.state.InvoiceId)
        }
        else if (role == 7 && group == 7) {
            await this.props.updateStatusForFinance(6, this.state.InvoiceId)
        }
        await this.dataSync()
    }
    DocumentCommentsByDocumentIdPopUpModal() {
        this.setState({ DocumentCommentsByDocumentIdPopUpModal: !this.state.DocumentCommentsByDocumentIdPopUpModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.DocumentCommentsByDocumentIdPopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleDocumentCommentsByDocumentIdPopUpModal = async (e) => {
        await this.setState({ DocumentCommentsByDocumentIdPopUpModal: !this.state.DocumentCommentsByDocumentIdPopUpModal, varId: "", varPoId: "", vardocumentTypeId: "", vardrawingDocumentDetailId: "" });
        if (this.state.DocumentCommentsByDocumentIdPopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    rowClick = async (documentId, poId, documentTypeId, drawingDocumentDetailId) => {
        console.log(documentId, 'incdex')
        // console.log(this.state.invoicetabledata, 'invoicetabledata')
        // let id = this.state.invoicetabledata[index].InvoiceId
        // console.log(id,"idddd")
        await this.setState({
            varId: documentId,
            varPoId: poId,
            vardocumentTypeId: documentTypeId,
            vardrawingDocumentDetailId: drawingDocumentDetailId
        })
        await this.DocumentCommentsByDocumentIdPopUpModal(this.state.varId)
    }
    // ? open version modal
    async OpenVersionModal(uploadedId) {
        let versionList = [];
        console.log(uploadedId, "this.state.uploadID")
        let stateVal = this.state.OpenVersionmodal;
        this.setState({ OpenVersionmodal: !stateVal, uploadedId: uploadedId });
    }
    handleFileForTransmittleDoc(e) {
        let transmittalFile = []
        console.log(e.target.files, "PPPPPPPPPPPP")
        transmittalFile = e.target.files
        this.setState({ transmittalFile })
    }
    uploadTransmittalFile = async (DocumentDetailsid) => {
        if (this.state.transmittalFile.length < 1) {

            swal("Please upload some valid document", { icon: "error" })

            return false;
        }
        var result = await this.props.uploadFileGeneric([this.state.transmittalFile[0]], AuthHandler.getUserID())
        console.log(result, "IIIIIIIIIIIIIIIIIIIIIIIIIIII")
        // console.log(result.results[0].DocumentId,result.results[0].CreatedOn,"IIIIIIIIIIIIIIIIIIIIIIIIIIII")
        const input = {
            DocumentDetailsid: DocumentDetailsid,
            DocumentId: result.results[0].DocumentId,
            RoleId: Object.keys(AuthHandler.getRoles())[0],
            GroupId: Object.keys(AuthHandler.getGroups())[0],
            UploadedBy: AuthHandler.getUserID(),
            CreatedOn: result.results[0].CreatedOn
        }
        // console.log(input,"IKIKIIIKIKK")
        await this.props.UpdateTransmittalDocumentDetails(input)
        this.dataSync()
    }
    addDocumentmodal(indicator) {
        this.setState({ addDocumentmodal: !this.state.addDocumentmodal, indicator });

        if (this.state.addDocumentmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    setTransmittleDocumentName(event) {
        this.setState({ transmittleDocumentName: event.target.value })
        console.log(this.state.transmittleDocumentName)
    }
    // ? adds drawing to the drawing list
    addDocumentstoList = async (indicator) => {
        // ? inserting new document in the drawing list
        await this.props.postPoTransmittleDocumnetDtails({
            PoId: this.state.poID,
            DocumentTypeName: this.state.transmittleDocumentName,
            indicator: indicator,
        })

        // ? setting the document name input to blank
        await this.setState({
            transmittleDocumentName: ''
        })

        // ? syncing data
        await this.dataSync()
        // ? closing modal
        await this.addDocumentmodal()
    }
    updateTransmittleStatus = async (DocumentDetailsid) => {
        const input = {
            DocumentDetailsid: DocumentDetailsid,
            DocumentId: 0,
            RoleId: 0,
            GroupId: 0,
            UploadedBy: 0,
            CreatedOn: 0,
            isDownloaded: 1,
            DownloadedDate: new Date(),
            delInd: 0,
        }
        // console.log(input,"IKIKIIIKIKK")
        await this.props.UpdateTransmittalDocumentDetails(input)
        await this.dataSync()
    }
    DeleteTransmittalDocument = async (DocumentDetailsid) => {
        const input = {
            DocumentDetailsid: DocumentDetailsid,
            DocumentId: 0,
            RoleId: 0,
            GroupId: 0,
            UploadedBy: 0,
            CreatedOn: 0,
            isDownloaded: 0,
            DownloadedDate: "",
            delInd: 1,
        }
        console.log("jkjkjkjkjkjk", input, "IKIKIIIKIKK")
        this.props.UpdateTransmittalDocumentDetails(input)
        await this.dataSync()
    }
    POCommentPopUpModal() {
        this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.POCommentPopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    approveByCPMandTPM = async (item, ActedGroupId) => {
        // if (item.find())
        // console.log(item,this.state.poID,AuthHandlerInstance.getUserPayLoad().fullName,"{{{{{{{{{{")
        await this.props.postUpdateAdvanceDocumentStatus(
            0,
            ActedGroupId,
            this.state.poID,
            0,
            1,
            AuthHandler.getUserID(),
            AuthHandler.getUserPayLoad().fullName,
            new Date(),
            item.PaymentTypeId,
            item.TypeFor
        ).then(async () => {
            toast.success(`Document is Approved`, {
                duration: 6000
            });
            await this.dataSync()
        })

    }

    approveByCPMandTPMPartial = async (item, ActedGroupId) => {
        // if (item.find())
        // console.log(item, this.state.approvalDetailsByCPMorTPMPartial,"{{{{{{{{{{")
        // return false
        var userDetails = AuthHandler.getUserPayLoad()
        // console.log(userDetails,"{{{{{{{{{{")
        var params = {
            AdvanceStageDocumentMappingIdPartial: 0,
            approvalStatus: 1,
            approvedBy: userDetails.userId,
            approvedByName: userDetails.fullName,
            approvedOn: new Date(),
            poId: item.PoId,
            PaymentType: item.PaymentTypeId,
            TypeFor: item.TypeFor,
            Counter: item.Counter,
            ActedGroupId: ActedGroupId,
            documentTypeId: 0
        }
        await this.props.UpdateApprovalForAdvanceDocumentPartial(params)
        await toast.success(`Document is Approved`, {
            duration: 6000
        });
        await this.dataSync()

    }

    togglePOCommentPopUpModal(e) {
        this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal, varPoId: "", varDocumentId: "" });
        if (this.state.POCommentPopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    rowClickPoComments = async (PurchaseOrderId, POAcceptanceDocumentID) => {
        console.log(PurchaseOrderId, POAcceptanceDocumentID, 'incdex')
        await this.setState({ varPoId: PurchaseOrderId, varDocumentId: POAcceptanceDocumentID })
        await this.POCommentPopUpModal()
    }

    submitInvoiceDocuments = async (item, type = '') => {
        await this.setState({ loading: true })

        console.log(item, this.state.poID)
        let count = 0;
        for (let index = 0; index < item.Documents.length; index++) {
            if (item.Documents[index].DocumentTypeId !== 40 && !item.Documents[index].AdvanceStageDocumentMappingId) {
                count = count + 1
            }
        }
        if (count > 0) {
            await this.setState({ loading: false })
            swal("Please upload all invoice document", { icon: "error" })
            return false;
        }
        let data = {
            PoId: this.state.poID,
            PaymentTypeId: item.PaymentTypeId,
            PaymentType: type === 'Draft Documents' ? 'Draft Documents' : item.PaymentType,
            TypeFor: item.TypeFor,
            Summited_ON: new Date(),
            InvoiceId: item.InvoiceId,
        }
        // console.log(data,"DataCheck")
        // return false
        await this.props.submitInvoiceDocuments(data)
        await this.dataSync()
        console.log(this.props.poDetails.poDetailsForAdvance, count, 'this.props.poDetails.poDetailsForAdvance')
    }
    submitInvoiceDocumentsPartial = async (item) => {
        await this.setState({ loading: true })
        // console.log(item, this.state.poID)
        // return false
        let count = 0;
        for (let index = 0; index < item.Documents.length; index++) {
            if (item.Documents[index].DocumentTypeId !== 40 && !this.state.paymentTermPartialDetails[item.Documents[index].AdvanceStageDocumentMappingIdPartial]) {
                count = count + 1
            }
        }
        if (count > 0) {
            await this.setState({ loading: false })
            swal("Please upload all invoice document", { icon: "error" })
            return false;
        }
        item.Documents.map(async (elem) => {
            var params = {
                documentId: 0,
                AdvanceStageDocumentMappingId: elem.AdvanceStageDocumentMappingIdPartial,
            }
            await this.props.UpdatePartialPaymentDetails(params)
        })
        // await this.props.submitInvoiceDocuments(data)
        await this.dataSync()
        console.log(this.state.paymentTermPartialDetails, count, 'this.state.paymentTermPartialDetails')
    }
    InsertInvoiceDetailsForSupplier = async (data) => {
        // await this.setState({loading:true})
        if (this.state.selectedFile.length < 1) {
            swal("Please upload some valid document", { icon: "error" })
            return false;
        }
        if (this.state.InvoiceNo.trim() == '') {
            swal("Please enter invoice number", { icon: "error" })
            return false;
        }
        if (this.state.InvoiceDate.trim() == '') {
            swal("Please enter invoice date", { icon: "error" })
            return false;
        }
        if (parseFloat(this.state.InvoiceAmount) == 0) {
            swal("Please enter invoice amount", { icon: "error" })
            return false;
        }
        await this.AcceptmodalForSupplier(data)
        await this.onclickUpload(data, 1)
        // await this.setState({loading:false})
    }
    InsertInvoiceDetailsForSupplierPartial = async (data) => {
        if (this.state.selectedFile.length < 1) {
            swal("Please upload some valid document", { icon: "error" })
            return false;
        }
        if (this.state.InvoiceNo.trim() == '') {
            swal("Please enter invoice number", { icon: "error" })
            return false;
        }
        if (this.state.InvoiceDate.trim() == '') {
            swal("Please enter invoice date", { icon: "error" })
            return false;
        }
        if (parseFloat(this.state.InvoiceAmount) == 0) {
            swal("Please enter invoice amount", { icon: "error" })
            return false;
        }
        await this.AcceptmodalForSupplierPartial()
        await this.onclickUploadPartial(data, 1)
    }
    handleSwitch = async (checkedSwitch) => {
        console.log("hjhjhjhjhj", checkedSwitch, "event.target")
        let switchValue = 0
        if (checkedSwitch == true) {
            switchValue = 1
        }
        await this.setState({ checkedSwitch, switchValue })
    }
    handleSwitchByApTeam = async (checkedSwitch) => {
        console.log("hjhjhjhjhj", checkedSwitch, "hjhjhjhjhj")
        let val = 0
        if (checkedSwitch == true) {
            val = 2
        }
        await this.setState({ checkedSwitch, checkedSwitchByApTeam: 1, switchValue: val })
    }
    handleSelectGRN = async (e) => {
        let input = e.value
        let GRNbyPOId = this.state.GRNbyPOId
        let GRNTableData = GRNbyPOId.filter((data) => data.GRNDocNo == input)
        console.log("Dlklklkl", GRNTableData, GRNbyPOId)
        await this.setState({ GRNDocNo: input, GRNTableData })
    }
    GRNSubmit = async (item) => {
        if (this.state.selectedFile.length < 1) {
            swal("Please upload some valid document", { icon: "error" })
            return false;
        }
        await this.setState({ InvoiceIdForGRN: item.InvoiceId, infoValGRN: 0, GRNTableData: [] })
        await this.GRNModal()
    }
    SubmitGRNData = async () => {
        if (this.state.GRNDocNo == '') {
            swal("Please A GRN First", { icon: "error" })
            return false;
        }
        var result = await this.props.uploadFileGeneric([this.state.files[122].fileInfo], AuthHandler.getUserID())
        let documentId = result.results[0].DocumentId
        console.log("documentId", documentId)
        let inputdata = {
            InvoiceId: this.state.InvoiceIdForGRN,
            GRNDocNo: this.state.GRNDocNo,
            GRNDocumentId: documentId
        }
        await this.props.postGRNDetails(inputdata)
        await this.GRNModal()
        await this.dataSync()
        await toast.success(`GRN Submitted`, {
            duration: 4000
        });

    }
    GRNinfo = async (infoValGRN, input) => {
        let GRNTableData = input
        console.log(input)
        await this.setState({ infoValGRN, GRNTableData })
        await this.GRNModal()
    }
    handleEmail = async (e) => {
        let input = e.target.value
        this.setState({ AdditionalEmailId: input })
    }
    AddEmailId = async (VendorEmail) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
        let input = {
            VendorEmail: VendorEmail,
            EmailId: this.state.AdditionalEmailId
        }
        if (!regex.test(input.EmailId) || input.EmailId == '') {
            swal("This is not a valid email format!", { icon: 'error' })
            return false
        }
        await this.props.postAdditionalEmailId(input)
        await toast.success('Email Id Added', {
            duration: 2000
        });
        await this.dataSync()
    }
    //Open Modal-------------------
    BGModal = async (data, val = "") => {
        if (this.state.selectedFile.length < 1) {
            swal("Please upload some valid document", { icon: "error" })
            return false;
        }

        let bgModalData = {}

        if (data && data.BGListDetailsId) {

            await this.props.getBGListDetails()
            bgModalData = await this.props.expediting.bgDetails.recordset.find(elem => elem.BGListDetailsId == data.BGListDetailsId)
            await this.setState({ BGModal: !this.state.BGModal, newRecord: {}, CurrencyInput: "", BGupload: data, partialFlag: val, bgModalData });

            if (this.state.BGModal == true) {
                this.setState({ opacity: "" })
            }
            else {
                await this.setState({ opacity: "0.2" })
            }
        }
        else {
            await this.setState({ BGModal: !this.state.BGModal, newRecord: {}, CurrencyInput: "", BGupload: data, partialFlag: val });
            console.log(this.state.BGModal, "sdfvhvsdfhvjsd")
            if (this.state.BGModal == true) {
                this.setState({ opacity: "" })
            }
            else {
                await this.setState({ opacity: "0.2" })
            }
        }

        
    }
    BGModalForPreUploadFiles = async (data, val = "") => {
        await this.setState({ BGModal: !this.state.BGModal, newRecord: {}, CurrencyInput: "", BGupload: data, partialFlag: val });
        if (this.state.BGModal == true) {
            this.setState({ opacity: "" })
        }
        else {
            await this.setState({ opacity: "0.2" })
        }
    }
    //Open Modal-------------------
    addAndUpdateBGModal = async (data = "") => {
        let bgModalData = {}
        if (data != "") {
            await this.props.getBGListDetails()
            bgModalData = await this.props.expediting.bgDetails.recordset.find(elem => elem.BGListDetailsId == data.BGListDetailsId)
        }
        await this.setState({ addAndUpdateBGModal: !this.state.addAndUpdateBGModal, addUpdateBGModalData: data, bgModalData });
        console.log("addUpdateBGModalData", this.state.bgModalData)
        if (this.state.addAndUpdateBGModal == true) {
            this.setState({ opacity: "" })
        }
        else {
            await this.setState({ opacity: "0.2" })
        }
    }
    handleText = (e) => {
        let val = e.target.value
        let key = e.target.name
        
        if(this.state.BGupload.BGListDetailsId){
            let obj = { ...this.state.bgModalData, [key]: val }
            console.log("OBJOBJ", obj)
           this.setState({ bgModalData: obj })
        }
        else{
            let obj = { ...this.state.newRecord, [key]: val }
             console.log("OBJOBJ", obj)
            this.setState({ newRecord: obj })
        }
        //console.log(key,e.target.value)
    }

    handlvalueText = (value, name) => {
        console.log(value, name)
        let obj = { ...this.state.newRecord, [name]: value }
        this.setState({ newRecord: obj })
    }
    handleSubmitBGDetails = async (input) => {
        let valid = true;
    
        this.setState({ loading: true  }) 

        
        if(!this.state.BGupload.BGListDetailsId){
            
            if (!('Document_Date' in this.state.newRecord) || (this.state.newRecord.Document_Date == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid Date", { icon: "error" })
                return false;
            }
            if (!('Gurantee_No' in this.state.newRecord) || (this.state.newRecord.Gurantee_No == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid Gurantee No.", { icon: "error" })
                return false;
            }
            if (!('BG_Amount' in this.state.newRecord) || (this.state.newRecord.BG_Amount == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid BG Amount", { icon: "error" })
                return false;
            }
            if (!('Expiry_Date' in this.state.newRecord) || (this.state.newRecord.Expiry_Date == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid Expiry Date", { icon: "error" })
                return false;
            }
            if (!('Claim_Date' in this.state.newRecord) || (this.state.newRecord.Claim_Date == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid Claim Date", { icon: "error" })
                return false;
            }
            if (!('Bank_Name' in this.state.newRecord) || (this.state.newRecord.Bank_Name == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid Bank Name", { icon: "error" })
                return false;
            }
            if (!('Address_1' in this.state.newRecord) || (this.state.newRecord.Address_1 == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid Address 1", { icon: "error" })
                return false;
            }
            if (!('City' in this.state.newRecord) || (this.state.newRecord.City == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid City", { icon: "error" })
                return false;
            }
            // if (!('PinCode' in this.state.newRecord) || (this.state.newRecord.PinCode == '' || this.state.newRecord.PinCode.length != 6)) {
            //this.setState({ loading: false  })    
              // swal("Please Enter Valid Pin Code", { icon: "error" })
            //     return false;
            // }
            if (!('Country' in this.state.newRecord) || (this.state.newRecord.Country == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid Country", { icon: "error" })
                return false;
            }
            if (!('Currency' in this.state.newRecord) || (this.state.newRecord.Currency == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid Currency", { icon: "error" })
                return false;
            }
            if (!('Branch_Email' in this.state.newRecord) || (this.state.newRecord.Branch_Email == '')) {
                this.setState({ loading: false  })  
                swal("Please Enter Valid Email Id", { icon: "error" })
                return false;
            }
        }

        
        if (!valid) {
            console.log(valid)
            this.setState({ loading: false  })  
            swal("Please Fill out the missing fields", { icon: "error" })
            return false;
        }

       
        if (this.state.partialFlag == "Pre-Upload-files") {
            let obj = { ...this.state.newRecord, ["poId"]: this.state.poID, ["TypeFor"]: this.state.BGupload.TypeFor, ["BGDocId"]: this.state.BGupload.DocumentId }
            await this.props.postBGListDetails(obj)
            await this.setState({ newRecord: {}, partialFlag: "", loading: false })
            await this.BGModalForPreUploadFiles()
            await this.dataSync()
            await toast.success(`BG Details Updated`, {
                duration: 2000
            });
        }
        else if (this.state.partialFlag == "Partial") {
            console.log("sdhbfhsbdhfs----------------Partial")
            await this.onclickUploadPartial(this.state.BGupload, 0, 1)
            this.setState({ loading: false  })  
        } else {
            console.log(this.state.BGupload, "sdhbfhsbdhfs----------------jvsdhhsjf")
            
            await this.onclickUpload(this.state.BGupload, 0, 1)
            this.setState({ loading: false  })  
        }
    }
    setLoader = async (e) => {
        console.log(e, 'loader check')
        this.setState({ loading: e })
    }
    handleSelectCurrency = async (e) => {
        let selectedCurrency = e.value
        let SelectCurrencyArray = []
        SelectCurrencyArray.push(e)
        let obj = { ...this.state.newRecord, ['Currency']: e.value }
        await this.setState({ selectedCurrency, SelectCurrencyArray, newRecord: obj })
    }
    handleEmail = async (e) => {
        let input = e.target.value
        this.setState({ AdditionalEmailId: input })
    }
    AddEmailId = async (VendorEmail) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
        let input = {
            VendorEmail: VendorEmail,
            EmailId: this.state.AdditionalEmailId
        }
        if (!regex.test(input.EmailId) || input.EmailId == '') {
            swal("This is not a valid email format!", { icon: 'error' })
            return false
        }
        await this.props.postAdditionalEmailId(input)
        await toast.success('Email Id Added', {
            duration: 2000
        });
        await this.dataSync()
    }
    render() {
        var varId = this.state.varId
        var varPoId = this.state.varPoId
        var vardocumentTypeId = this.state.vardocumentTypeId
        var vardrawingDocumentDetailId = this.state.vardrawingDocumentDetailId
        var roles = authInstance.getRoles()
        var groups = authInstance.getGroups()
        const varDocumentId = this.state.varDocumentId
        if (this.props.masterReducerData.loading == false) {
            this.state.paymentMethod = this.props.masterReducerData.masterdata.recordset
        }

        console.log (this.state.BgDraftDocTableData && this.state.BgDraftDocTableData.length>0 && this.state.BgDraftDocTableData.some(item => 
            item.PurchaseOrderID == this.state.poID && item.Status == 1 && item.BgType == "ABG"
    ), "sdjbhfhfvbgdsfj")
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        const TransmittalTableConstants = () => {
            return [
                {
                    title: 'Document Name',
                    className: 'headeralign min-vw-200',
                    render: rowData => {
                        return <span>{rowData.DocumentName}</span>;
                    },
                },
                {
                    title: 'Uploaded By',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.UploadedByName}</span>;
                    },
                },
                {
                    title: 'Submitted On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.CreatedOn ? dateFormater(rowData.CreatedOn) : '---'}</span>;
                    },
                },
                {
                    title: 'Downloaded On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.DownloadedDate ? dateFormater(rowData.DownloadedDate) : '---'}</span>;
                    },
                },
                {
                    title: 'Actions',
                    className: 'text-center',
                    render: rowData => {
                        if (rowData.DocumentId == null) {
                            if (roles[15] || (roles[7])) {
                                return (
                                    <div className="row view-button">
                                        <div className="col pt-2">
                                            <input type="file" className="form-control-file" onChange={(e) => this.handleFileForTransmittleDoc(e)} id="exampleFormControlFile1" />
                                        </div>
                                        <div className="col">
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={() => this.uploadTransmittalFile(rowData.DocumentDetailsid)} icon={"cloud-upload-alt"} title="Upload Invoice" color={"black"} size="2x" />
                                        </div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div className="view-button">
                                        <FontAwesomeIcon icon={"stopwatch"} title="Awaiting for upload" color={"black"} size="lg" />
                                    </div>
                                );
                            }
                        }
                        else {
                            return (
                                <div className="view-button">
                                    <div className="row">
                                        <div className="col align-middle">
                                            {(roles[5] || (roles[7] === null)) && rowData.POId !== 0 ?
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" onClick={() => this.updateTransmittleStatus(rowData.DocumentDetailsid)} />
                                                </a>
                                                :
                                                <>
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="Download" color={"black"} size="2x" cursor="Pointer" />
                                                    </a>
                                                    {rowData.isDownloaded == 0 && rowData.POId !== 0 && Object.keys(roles)[0].includes(rowData.RoleId) ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pl-2" icon={"trash-alt"} title="Delete" color={"red"} size="2x" cursor="Pointer" onClick={() => this.DeleteTransmittalDocument(rowData.DocumentDetailsid)} />
                                                        : null}
                                                </>
                                            }
                                        </div>
                                    </div>
                                    {this.props.expediting && this.props.expediting.getPoTransmittleDOcuments ?
                                        rowData.POId === 0 ?
                                            <span className="badge badge-primary">Fixed PO Annexure</span>
                                            : (<span className={"badge " + this.state.TransmittalDocStatus[rowData.isDownloaded]['badge']}>
                                                {`${this.state.TransmittalDocStatus[[rowData.isDownloaded]]['title']}`}
                                            </span>)
                                        : null}
                                </div>
                            )
                        }
                    },
                },
            ];
        };
        const TransmittalTableConstantsDrawing = () => {
            return [
                {
                    title: 'Document Name',
                    className: 'headeralign min-vw-200',
                    render: rowData => {
                        return <span>{rowData.DocumentName}</span>;
                    },
                },
                {
                    title: 'Uploaded By',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.UploadedByName}</span>;
                    },
                },
                {
                    title: 'Submitted On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.CreatedOn ? dateFormater(rowData.CreatedOn) : '---'}</span>;
                    },
                },
                {
                    title: 'Downloaded On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.DownloadedDate ? dateFormater(rowData.DownloadedDate) : '---'}</span>;
                    },
                },
                {
                    title: 'Actions',
                    className: 'text-center',
                    render: rowData => {
                        if (rowData.DocumentId == null) {
                            if (roles[15] || roles[7]) {
                                return (
                                    <div className="row view-button">
                                        <div className="col pt-2">
                                            <input type="file" className="form-control-file" onChange={(e) => this.handleFileForTransmittleDoc(e)} id="exampleFormControlFile1" />
                                        </div>
                                        <div className="col">
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={() => this.uploadTransmittalFile(rowData.DocumentDetailsid)} icon={"cloud-upload-alt"} title="Upload Invoice" color={"black"} size="2x" />
                                        </div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div className="view-button">
                                        <FontAwesomeIcon icon={"stopwatch"} title="Awaiting for upload" color={"black"} size="lg" />
                                    </div>
                                );
                            }
                        }
                        else {
                            return (
                                <div className="view-button">
                                    <div className="row">
                                        <div className="col align-middle">
                                            {(roles[5] || (roles[7] === null)) ?
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="Download" color={"black"} size="2x" onClick={() => this.updateTransmittleStatus(rowData.DocumentDetailsid)} />
                                                </a>
                                                :
                                                <>
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="Download" color={"black"} size="2x" cursor="Pointer" />
                                                    </a>
                                                    {rowData.isDownloaded == 0 && Object.keys(roles)[0].includes(rowData.RoleId) ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pl-2" icon={"trash-alt"} title="Delete" color={"red"} size="2x" cursor="Pointer" onClick={() => this.DeleteTransmittalDocument(rowData.DocumentDetailsid)} />
                                                        : null}
                                                </>
                                            }
                                        </div>
                                    </div>
                                    {this.props.expediting && this.props.expediting.getPoTransmittleDOcuments ?
                                        (<span className={"badge " + this.state.TransmittalDocStatus[rowData.isDownloaded]['badge']}>
                                            {`${this.state.TransmittalDocStatus[[rowData.isDownloaded]]['title']}`}
                                        </span>)
                                        : null}
                                </div>
                            )
                        }
                    },
                },
            ];
        };
        const partialPayment = () => {
            return [
                // console.log(rowData,"popopopopop")
                {
                    title: 'Document Type',
                    className: 'headeralign',
                    render: rowData => {
                        // return JSON.stringify(rowData);
                        return <span>{`${rowData.DocumentTypeName} (${rowData.Amount}${rowData.AmountTypeName})`}</span>;
                    },
                },
                {
                    title: 'Acting Depart',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{(roles[5]) ? "SMS Team" : rowData.approvalStatus == 3 ? this.props.poDetails.paymentTermDetailsByPoId.vendorName : rowData.GroupName}</span>;
                    },
                },
                {
                    title: 'Submitted On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.CreatedOn ? dateFormater(rowData.CreatedOn) : '---'}</span>;
                    },
                },
                {
                    title: 'Acted On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.approvedOn ? dateFormater(rowData.approvedOn) : '---'}</span>;
                    },
                },
                {
                    title: 'Actions',
                    className: 'text-center',
                    render: rowData => {
                        if ((roles[5] || (roles[7])) && (rowData.DocumentId == null || rowData.approvalStatus == 3 || rowData.approvalStatus == 2)) {
                            if (rowData.DocumentId == null || rowData.approvalStatus == 3 || rowData.approvalStatus == 2) {
                                return (
                                    <>
                                        <div className="view-button justify-content-between row">
                                            <div className="col dark">
                                                <input type="file" className="form-control-file" style={{ width: "69%" }} onChange={(e) => { this.handleFileInput(e, rowData) }} id="exampleFormControlFile1" />
                                            </div>
                                            <div className="col-md-4 mr-2">
                                                {rowData.DocumentTypeId == 84 || rowData.DocumentTypeId == 73 || rowData.DocumentTypeId == 52 || rowData.DocumentTypeId == 36 || rowData.DocumentTypeId == 41 || rowData.DocumentTypeId == 46 || rowData.DocumentTypeId == 101 || rowData.DocumentTypeId == 110 || rowData.DocumentTypeId == 111 || rowData.DocumentTypeId == 112 || rowData.DocumentTypeId == 113 || rowData.DocumentTypeId == 114 || rowData.DocumentTypeId == 115 || rowData.DocumentTypeId == 118 || rowData.DocumentTypeId == 119 ?
                                                    <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={(e) => { this.AcceptmodalForSupplierPartial(rowData) }} color={"black"} title={"Upload File"} size="lg" />
                                                    : rowData.DocumentTypeId == 70 || rowData.DocumentTypeId == 43 ?
                                                        <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={() => this.BGModal(rowData, "Partial")} color={"black"} title={"Upload File"} size="lg" />
                                                        : <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={(e) => { this.onclickUploadPartial(rowData) }} color={"black"} title={"Upload File"} size="lg" />
                                                }
                                                {rowData.approvalStatus == 3 ?
                                                    <>
                                                        <FontAwesomeIcon className="align-middle mr-2" icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                        <FontAwesomeIcon className="align-middle" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(rowData.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, rowData.DocumentTypeId, 0)} />
                                                    </>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                        <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {this.state.docStatus[rowData.approvalStatus]['title']}
                                        </span>
                                    </>
                                )
                            }
                            else if (rowData.DocumentId != null) {
                                return (
                                    <>
                                        <div className="row align-middle">
                                            <div className="col align-middle">
                                                <FontAwesomeIcon
                                                    className="align-middle pr-2"
                                                    icon={"code-branch"}
                                                    color={"black"}
                                                    title="Document Version"
                                                    size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                </a>
                                                <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, rowData.DocumentTypeId, 0)} />
                                                {!roles[5] && (rowData.DocumentTypeId == 70 || rowData.DocumentTypeId == 43) && rowData.BGListDetailsId != null ?
                                                    <FontAwesomeIcon className="align-middle" icon={"info-circle"} color={"blue"} title="info" size="lg" cursor="pointer" onClick={() => this.addAndUpdateBGModal(rowData)} />
                                                    : null}
                                            </div>
                                        </div>
                                        <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {this.state.docStatus[rowData.approvalStatus]['title']}
                                        </span>
                                    </>
                                )
                            }
                        }
                        else {
                            if (rowData.approvalStatus == 6 && Object.keys(groups).includes(rowData.ActingDeptGroupId.toString())) {
                                return (
                                    <>
                                        <div className="row">
                                            <div className="col align-middle">
                                                <FontAwesomeIcon className="align-middle pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="Download" color={"black"} size="2x" />
                                                </a>
                                                {roles[8] == true && groups[8] == true && ((rowData.DocumentTypeId == 84 || rowData.DocumentTypeId == 73 || rowData.DocumentTypeId == 52 || rowData.DocumentTypeId == 36 || rowData.DocumentTypeId == 41 || rowData.DocumentTypeId == 46 || rowData.DocumentTypeId == 101 || rowData.DocumentTypeId == 110 || rowData.DocumentTypeId == 111 || rowData.DocumentTypeId == 112 || rowData.DocumentTypeId == 113 || rowData.DocumentTypeId == 114 || rowData.DocumentTypeId == 115 || rowData.DocumentTypeId == 118 || rowData.DocumentTypeId == 119)) ?
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.AcceptmodalPartial(rowData.AdvanceStageDocumentMappingIdPartial, rowData, rowData.DocumentId)} />
                                                    : <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents partial", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.approved)} />
                                                }
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents partial", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, rowData.DocumentTypeId, 0)} />
                                                {!roles[5] && (rowData.DocumentTypeId == 70 || rowData.DocumentTypeId == 43) && rowData.BGListDetailsId != null ?
                                                    <FontAwesomeIcon className="align-middle" icon={"info-circle"} color={"blue"} title="info" size="lg" cursor="pointer" onClick={() => this.addAndUpdateBGModal(rowData)} />
                                                    : null}
                                            </div>
                                        </div>
                                        <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {this.state.docStatus[rowData.approvalStatus]['title']}
                                        </span>
                                    </>
                                )
                            }
                            else if (rowData.DocumentId != null) {
                                return (
                                    <>
                                        <div className="row align-middle">
                                            <div className="col align-middle">
                                                <FontAwesomeIcon className="align-middle pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                </a>
                                                <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, rowData.DocumentTypeId, 0)} />
                                                {!roles[5] && (rowData.DocumentTypeId == 70 || rowData.DocumentTypeId == 43) && rowData.BGListDetailsId != null ?
                                                    <FontAwesomeIcon className="align-middle" icon={"info-circle"} color={"blue"} title="info" size="lg" cursor="pointer" onClick={() => this.addAndUpdateBGModal(rowData)} />
                                                    : groups[9] && (rowData.DocumentTypeId == 70 || rowData.DocumentTypeId == 43) && rowData.BGListDetailsId == null ?
                                                        <FontAwesomeIcon className="align-middle" icon={"plus-circle"} color={"blue"} title="info" size="lg" cursor="pointer" onClick={() => this.BGModalForPreUploadFiles(rowData, "Pre-Upload-files")} />
                                                        : null}
                                            </div>
                                        </div>
                                        <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {this.state.docStatus[rowData.approvalStatus]['title']}
                                        </span>
                                    </>
                                )
                            }
                        }
                    },
                },
            ];
        };

        // console.log(this.state.bgModalData, "sdjgvfdsfsdfsdfsdfsdfsdfsdfsd")
        return (
            <div className="Container-fluid">
                {this.state.loading == true ?
                    <div className="backdrop">
                        <Loading />
                    </div>
                    : ""}
                {/*----------Document comment-------------- */}
                {
                    varId ? (<DocumentCommentsByDocumentIdPopUp action={this.state.DocumentCommentsByDocumentIdPopUpModal} toggleDocumentCommentsByDocumentIdPopUpModal={(e) => this.toggleDocumentCommentsByDocumentIdPopUpModal(e)} DocumentId={varId} PoId={varPoId} PoLineId={0} rowDocumentTypeId={vardocumentTypeId} rowDrawingDocumentDetailId={vardrawingDocumentDetailId} path='/ExpeditingPOAcceptanceTrail' />) : null
                }
                {/*----------Document Comment end  */}

                {/*----------File version start  */}
                {this.state.uploadedId && this.state.OpenVersionmodal && <FileVersionModal OpenVersionmodal={this.state.OpenVersionmodal} uploadedId={this.state.uploadedId} OpenVersionModal={(uploadId) => this.OpenVersionModal(uploadId)} />}
                {/*----------File version end  */}

                {/* Revise PopUp for POAcceptance */}
                {/*----------Document comment-------------- */}
                {
                    varDocumentId ? (<POCommentPopUp action={this.state.POCommentPopUpModal} togglePOCommentPopUpModal={(e) => this.togglePOCommentPopUpModal(e)} DocumentId={varDocumentId} varPoId={varPoId} path='/ExpeditingPOAcceptanceTrail' />) : null
                }
                {/*----------Document Comment end  */}
                {/* ----Modal Start----- */}

                <CancelPOAcceptance action={this.state.CancelPOAcceptanceModal} toggleCancelPOAcceptanceModal={(e) => this.toggleCancelPOAcceptanceModal(e)} path='/PoAcceptanceTrail' />
                <UploadPopUpPoAcceptance action={this.state.UploadPOAcceptanceModal} poID={this.state.poID} toggleUploadPOAcceptanceModal={(e) => this.toggleUploadPOAcceptanceModal(e)} path='/PoAcceptanceTrail' />
                <RejectPOAcceptance action={this.state.ReviseModal} flagR={this.state.flagR} poID={this.state.poID} uploadID={this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId} datasync={this.dataSync} toggleReviseModal={(e) => this.toggleReviseModal(e)} setLoader={(e) => this.setLoader(e)} path='/PoAcceptanceTrail' />
                <UploadAcknowledgementPopUp action={this.state.UploadAcknowledgementModal} toggleUploadAcknowledgementModal={(e) => this.toggleUploadAcknowledgementModal(e)} path='/PoAcceptanceTrail' />
                {/* ----Modal End----- */}
                {/* ----------BG Modal Start---------------- */}
                <Modal isOpen={this.state.BGModal} className="modal-xl mr-2">
                    <div className={"modal-bg" + (this.state.BGModal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Add Details</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={() => this.BGModal()} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row">
                                    <div className="col-md-2"><b>BG Date</b></div>
                                    <div className="col-md-4">
                                        <input type="date" className="form-control" placeholder="Enter Your Text Here" name="Document_Date" id="date" max={formatDate(new Date())} onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Document_Date ? formatDate(this.state.bgModalData.Document_Date) : this.state.newRecord.Document_Date || ""} />
                                    </div>
                                    <div className="col-md-2"><b>BG No.</b></div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" placeholder="Gurantee No" name="Gurantee_No" min="1" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Gurantee_No ? this.state.bgModalData.Gurantee_No : this.state.newRecord.Gurantee_No || ""} /></div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>BG Amount</b></div>
                                    <div className="col-md-4">
                                        <div className='input-group'>
                                            <Select maxMenuHeight={500} className='modal-select' placeholder="Currency" name="Currency" value={this.state.bgModalData.Currency? [{value: this.state.bgModalData.Currency,label: this.state.bgModalData.Currency}]: this.state.SelectCurrencyArray} options={this.state.CurrencyArray} onChange={(e) => this.handleSelectCurrency(e)} />
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control" name="BG_Amount" min="1" value={this.state.bgModalData.BG_Amount? this.state.bgModalData.BG_Amount: this.state.newRecord.BG_Amount || ""} onValueChange={(value, e) => this.handlvalueText(value, e)} />
                                        </div>
                                    </div>
                                    <div className="col-md-2"><b>BG Expiry Date</b></div>
                                    <div className="col-md-4">
                                        <input type="date" className="form-control" placeholder="Expiry Date" name="Expiry_Date" min={formatDate(new Date())} onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Expiry_Date? formatDate(this.state.bgModalData.Expiry_Date): this.state.newRecord.Expiry_Date || ""} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>Claim Expiry Date</b></div>
                                    <div className="col-md-4">
                                        <input type="date" className="form-control" placeholder="Claim Date" name="Claim_Date" min={formatDate(new Date())} onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Claim_Date? formatDate(this.state.bgModalData.Claim_Date):this.state.newRecord.Claim_Date || ""} />
                                    </div>
                                    <div className="col-md-2"><b>Bank Name</b></div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" placeholder="Bank Name" name="Bank_Name" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Bank_Name? this.state.bgModalData.Bank_Name:this.state.newRecord.Bank_Name || ""} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>Branch Email</b></div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" placeholder="Branch Email Address" name="Branch_Email" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Branch_Email ? this.state.bgModalData.Branch_Email:this.state.newRecord.Branch_Email || ""} />
                                    </div>
                                    <div className="col-md-2"><b>Address1</b></div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" placeholder="Enter Address 1" name="Address_1" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Address_1? this.state.bgModalData.Address_1: this.state.newRecord.Address_1 || ""} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>Address 2</b></div>
                                    <div className="col-md-4"><input type="text" className="form-control" placeholder="Enter Address 2" name="Address_2" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Address_2 ? this.state.bgModalData.Address_2 : this.state.newRecord.Address_2 || ""} />
                                    </div>
                                    <div className="col-md-2"><b>City</b></div>
                                    <div className="col-md-4"><input type="text" className="form-control" placeholder="City" name="City" onChange={(e) => this.handleText(e)} value={ this.state.bgModalData.City? this.state.bgModalData.City: this.state.newRecord.City || ""} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>Pincode</b></div>
                                    <div className="col-md-4"><input type="number" className="form-control" placeholder="Pin Code" name="PinCode" min="1" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.PinCode? this.state.bgModalData.PinCode: this.state.newRecord.PinCode || ""} />
                                    </div>
                                    <div className="col-md-2"><b>Country</b></div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" placeholder="Country" name="Country" onChange={(e) => this.handleText(e)} value={ this.state.bgModalData.Country? this.state.bgModalData.Country: this.state.newRecord.Country || ""} />
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => this.BGModal()} type="submit">Cancel</button>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.handleSubmitBGDetails()} disabled={this.state.loading ? true: false} tpye="submit">Add Data</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                {/* ----------BG Modal End---------------- */}
                {/* ----------ADD and Check BG Modal Start---------------- */}
                <Modal isOpen={this.state.addAndUpdateBGModal} className="modal-xl mr-2">
                    <div className={"modal-bg" + (this.state.addAndUpdateBGModal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Bank Gurantee Details</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={() => this.addAndUpdateBGModal()} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row">
                                    <div className="col-md-2"><b>BG Date</b></div>
                                    <div className="col-md-4">
                                        <input type="date" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="Document_Date" max={formatDate(new Date())} onChange={(e) => this.handleText(e)} value={formatDate(this.state.bgModalData.Document_Date) || ""} />
                                    </div>
                                    <div className="col-md-2"><b>BG No.</b></div>
                                    <div className="col-md-4">
                                        <input type="text" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="Gurantee_No" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Gurantee_No || ""} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>Business Area</b></div>
                                    <div className="col-md-4">
                                        <input type="text" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="Bussiness_Area" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Bussiness_Area || ""} />
                                    </div>
                                    <div className="col-md-2"><b>BG Amount</b></div>
                                    <div className="col-md-4">
                                        <div className='input-group'>
                                            <span className="input-group-text">{this.state.bgModalData.Currency || ""}</span>
                                            <CurrencyInput readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} allowNegativeValue={false} decimalScale="2" className="form-control" name="BG_Amount" min="1" value={this.state.bgModalData.BG_Amount || ""} onValueChange={(value, e) => this.handlvalueText(value, e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>BG Expiry Date</b></div>
                                    <div className="col-md-4">
                                        <input type="date" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="Expiry_Date" min={formatDate(new Date())} onChange={(e) => this.handleText(e)} value={formatDate(this.state.bgModalData.Expiry_Date) || ""} />
                                    </div>
                                    <div className="col-md-2"><b>Claim Expiry Date</b></div>
                                    <div className="col-md-4">
                                        <input type="date" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="Claim_Date" max={formatDate(new Date())} onChange={(e) => this.handleText(e)} value={formatDate(this.state.bgModalData.Claim_Date) || ""} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>Bank Name</b></div>
                                    <div className="col-md-4">
                                        <input type="text" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="Bank_Name" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Bank_Name || ""} />
                                    </div>
                                    <div className="col-md-2"><b>Branch Email</b></div>
                                    <div className="col-md-4">
                                        <input type="text" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="Branch_Email" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Branch_Email || ""} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>Address 1</b></div>
                                    <div className="col-md-4">
                                        <input type="text" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="Address_1" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Address_1 || ""} />
                                    </div>
                                    <div className="col-md-2"><b>Address 2</b></div>
                                    <div className="col-md-4"><input type="text" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="Address_2" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Address_2 || ""} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>City</b></div>
                                    <div className="col-md-4"><input type="text" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="City" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.City || ""} />
                                    </div>
                                    <div className="col-md-2"><b>Pincode</b></div>
                                    <div className="col-md-4"><input type="number" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} className="form-control" name="PinCode" min="1" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.PinCode || ""} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-2"><b>Country</b></div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" readOnly={this.state.addUpdateBGModalData.BGListDetailsId ? true : false} name="Country" onChange={(e) => this.handleText(e)} value={this.state.bgModalData.Country || ""} />
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                    </div>
                </Modal>
                {/* ----------ADD and Check BG Modal End---------------- */}

                {/* ----------Revise Modal Start---------------- */}

                {this.state.showRevisedPopUp && <Modal className="modal-lg" isOpen={this.state.showRevisedPopUp} >
                    <div className={"modal-bg" + (this.state.OpenVersionmodal == true ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div className="modal-text"><h4 >{this.state.revisedPayload && this.state.revisedPayload.param && this.state.revisedPayload.param.documentTypeName ? `${this.state.revisedPayload.param.documentTypeName}` : null}</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={(e) => this.revisePopUpAction(false)} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div>
                            <ModalBody Style="modal-body">

                                <div className="row ">
                                    <div className="col-8"></div>
                                    <div className="col-4 pb-2">
                                    </div>
                                </div>

                                <div className="row col-sm-12" style={{ textAlign: "center", display: "none", top: "40%" }}>
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>

                                <div className="row ">
                                    <div className="col-sm-6">
                                        Upload Document (Optional)
                                    </div>
                                    <div className="col-sm-6">
                                        <input type="file" className="form-control-file" name="" onChange={(e) => { this.handleFileInputforRevision(e) }} id="exampleFormControlFile2" />
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-sm-6">
                                        Comment
                                    </div>
                                    <div className="col-sm-6">
                                        <textarea className="form-control" onChange={(e) => this.formChange(e)}>{this.state.reviseForm.comment}</textarea>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div className="">
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-2 float-right" onClick={() => this.formSaveAction()} type="submit">Save</button>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-2 " onClick={() => this.revisePopUpAction(false)} type="submit">Close</button>

                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                }

                {/* ----------Revise Modal End---------------- */}

                {/* ----Modal Start----- */}

                <Modal isOpen={this.state.modal} className="modal-lg">
                    <div className={"modal-bg" + (this.state.modal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header ">
                                <div><h4 >Update Payment Method</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div >
                            <ModalBody Style="modal-body ">
                                <div className="col-md-12 pt-2">
                                    <div className="row">
                                        <div className="col-md-6 pt-2 " ><b>Method of Payment :</b></div>
                                        <div className="col-md-6 ">
                                        </div>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms1 mt-2 ml-4 rounded-pill float-right" onClick={this.modalSubmit} type="submit">Send to Treasury Team</button>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.modal}> Cancel </button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>


                {/* ----Modal End-------- */}
                {/* ----Accept Modal Start----- */}

                <Modal isOpen={this.state.Acceptmodal} className="modal-lg">
                    <div
                        className={
                            "modal-bg" + (this.state.Acceptmodal === "false" ? "open" : "")
                        }
                    >
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div>
                                    <h4> Proforma Invoice Details </h4>
                                </div>
                                <button
                                    type="button"
                                    className="close"
                                    aria-label="Close"
                                    onClick={this.Acceptmodal}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div>
                            <ModalBody Style="modal-body">
                                {this.state.invoiceDetails.length > 0 && this.state.invoiceDetails.map((elem, index) =>
                                    <div key={index}>
                                        {console.log("lklklkl", this.state.invoiceDetails)}
                                        <div className="row pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b> Proforma Invoice No: </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <input type="text" className="form-control text-center" value={this.state.InvoiceNo ? this.state.InvoiceNo : elem.InvoiceNo} onChange={(e) => this.InvoiceNoInput(e)}></input>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <b>Proforma Invoice Date:</b>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <input type="date" max={formatDate(new Date())} className="form-control text-center" value={this.state.InvoiceDate ? this.state.InvoiceDate : formatDate(elem.InvoiceDate)} onChange={(e) => this.handleInvoiceDate(e)}></input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row  pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b> Project code: </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            className="form-control text-center"
                                                            value={this.props.poDetails.paymentTermDetailsByPoId.wbsCode ? (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 6) : "NA"}
                                                        ></input>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <b> Due Date:</b>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <input
                                                            type="date"
                                                            min={formatDate(new Date())}
                                                            max={formatDate(this.state.InvoiceDate)}
                                                            className="form-control text-center"
                                                            value={this.state.DueDate}
                                                            onChange={this.handleDueDate}
                                                        ></input>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        <div className="row pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b>Proforma Invoice Amount: </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                                                            value={this.state.InvoiceAmount ? this.state.InvoiceAmount : elem.InvoiceAmount}
                                                            onValueChange={(value, name) => this.InvoiceAmountInput(value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b> Exchange Rate 1: </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <CurrencyInput allowNegativeValue={false} decimalScale="4" className="form-control text-center"
                                                            value={this.state.ExchangeRate ? this.state.ExchangeRate : elem.ExchangeRate}
                                                            onValueChange={(value, name) => this.handleExchangeRate(value)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b> Currency: </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            className="form-control text-center"
                                                            value={this.props.poDetails.paymentTermDetailsByPoId.Currency ? this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() : "NA"}
                                                        ></input>
                                                    </div>
                                                </div>
                                            </div>
                                            {(elem.IsPartial != null || elem.IsPartial != 0) && elem.PaymentType != 3 ?
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <b>Opted For :</b>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <Switch onChange={(e) => this.handleSwitchByApTeam(e)} checked={this.state.checkedSwitchByApTeam != 0 ? this.state.checkedSwitch : elem.IsPartial} onColor="#86d3ff" onHandleColor="#2693e6" handleDiameter={30} uncheckedIcon={false} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" id="material-switch" />
                                                        </div>
                                                        <div className="col-md-4">
                                                            {this.state.checkedSwitchByApTeam != 0 ?
                                                                this.state.checkedSwitch ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>
                                                                : elem.IsPartial == 1 || elem.IsPartial == 2 ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}

                                        </div>
                                        <div className="row pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b>Proforma Invoice Amount (INR) : </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.ExchangeRate ? (elem.InvoiceAmount * this.state.ExchangeRate) : (elem.InvoiceAmount * elem.ExchangeRate)} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer ">
                                <div>
                                    <button className="btn2 btn-sms1 mt-2 rounded-pill ml-4 float-right" onClick={() => this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.DocumentTypeId, this.state.approvalStatus.approved, this.state.DocumentTypeName, this.state.docStatus['1'].status, this.state.dataFull, this.state.invoiceDetails)} type="submit">
                                        Accept
                                    </button>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.Acceptmodal}>{" "}Cancel{" "}</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>

                {/* ---- Accept Modal End-------- */}
                {/* ----Accept Modal Partial Start----- */}

                <Modal isOpen={this.state.AcceptmodalPartial} className="modal-lg">
                    <div
                        className={
                            "modal-bg" + (this.state.AcceptmodalPartial === "false" ? "open" : "")
                        }
                    >
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div>
                                    <h4> Proforma Invoice Details </h4>
                                </div>
                                <button
                                    type="button"
                                    className="close"
                                    aria-label="Close"
                                    onClick={this.AcceptmodalPartial}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div>
                            <ModalBody Style="modal-body">
                                {this.state.invoiceDetails.length > 0 && this.state.invoiceDetails.map((elem, index) =>
                                    <div key={index}>
                                        <div className="row pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b> Proforma Invoice No: </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <input type="text" className="form-control text-center" value={this.state.InvoiceNo ? this.state.InvoiceNo : elem.InvoiceNo} onChange={(e) => this.InvoiceNoInput(e)}></input>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <b>Proforma Invoice Date:</b>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <input type="date" max={formatDate(new Date())} className="form-control text-center" value={this.state.InvoiceDate ? this.state.InvoiceDate : formatDate(elem.InvoiceDate)} onChange={(e) => this.handleInvoiceDate(e)}></input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row  pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b> Project code: </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            className="form-control text-center"
                                                            value={this.props.poDetails.paymentTermDetailsByPoId.wbsCode ? (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 6) : "NA"}
                                                        ></input>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <b> Due Date:</b>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <input
                                                            type="date"
                                                            min={formatDate(new Date())}
                                                            max={formatDate(this.state.InvoiceDate)}
                                                            className="form-control text-center"
                                                            value={this.state.DueDate}
                                                            onChange={this.handleDueDate}
                                                        ></input>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        <div className="row pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b>Proforma Invoice Amount: </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                                                            value={this.state.InvoiceAmount ? this.state.InvoiceAmount : elem.InvoiceAmount}
                                                            onValueChange={(value, name) => this.InvoiceAmountInput(value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b> Exchange Rate : </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <CurrencyInput allowNegativeValue={false} decimalScale="4" className="form-control text-center" value={this.state.ExchangeRate ? this.state.ExchangeRate : elem.ExchangeRate} onValueChange={(value) => this.handleExchangeRate(value)} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="row pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b> Currency: </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            className="form-control text-center"
                                                            value={this.props.poDetails.paymentTermDetailsByPoId.Currency ? this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() : "NA"}
                                                        ></input>
                                                    </div>
                                                </div>
                                            </div>
                                            {elem.IsPartial != null || elem.IsPartial != 0 ?
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <b>Opted For :</b>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <Switch onChange={(e) => this.handleSwitchByApTeam(e)} checked={this.state.checkedSwitchByApTeam != 0 ? this.state.checkedSwitch : elem.IsPartial} onColor="#86d3ff" onHandleColor="#2693e6" handleDiameter={30} uncheckedIcon={false} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" id="material-switch" />
                                                        </div>
                                                        <div className="col-md-4">
                                                            {this.state.checkedSwitchByApTeam != 0 ?
                                                                this.state.checkedSwitch ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>
                                                                : elem.IsPartial == 1 || elem.IsPartial == 2 ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}

                                        </div>
                                        <div className="row pt-2 mt-4">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <b>Proforma Invoice Amount (INR): </b>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.ExchangeRate ? (elem.InvoiceAmount * this.state.ExchangeRate) : (elem.InvoiceAmount * elem.ExchangeRate)} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer ">
                                <div>
                                    <button className="btn2 btn-sms1 mt-2 rounded-pill ml-4 float-right" onClick={() => this.handleApprovalPartial(this.state.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.approved, this.state.dataFull, this.state.invoiceDetails, this.props.poDetails.paymentTermDetailsByPoId.poId)} type="submit">
                                        Accept
                                    </button>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.AcceptmodalPartial}>{" "}Cancel{" "}</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>

                {/* ---- Accept Modal Partial End-------- */}
                {/* ----Accept Modal For Supplier Start----- */}

                <Modal isOpen={this.state.AcceptmodalForSupplier} className="modal-lg">
                    <div
                        className={
                            "modal-bg" + (this.state.AcceptmodalForSupplier === "false" ? "open" : "")
                        }
                    >
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div>
                                    <h4> Invoice Details </h4>
                                </div>
                                <button
                                    type="button"
                                    className="close"
                                    aria-label="Close"
                                    onClick={this.AcceptmodalForSupplier}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div>
                            <ModalBody Style="modal-body">
                                <div className="row pt-2 mt-4">
                                    <div className="col-md-6 ">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <b> Invoice No: </b>
                                            </div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    // value={this.state.InvoiceNo}
                                                    value={this.state.InvoiceNo ? this.state.InvoiceNo : this.state.dataFullForSupplier && this.state.dataFullForSupplier.InvoiceNo ? this.state.dataFullForSupplier.InvoiceNo : ""}
                                                    onChange={this.InvoiceNoInput}
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <b>Invoice Date:</b>
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    type="date"
                                                    max={formatDate(new Date())}
                                                    className="form-control text-center"
                                                    // value={this.state.InvoiceDate}
                                                    value={this.state.InvoiceDate ? this.state.InvoiceDate : this.state.dataFullForSupplier && this.state.dataFullForSupplier.InvoiceDate ? formatDate(this.state.dataFullForSupplier.InvoiceDate) : ""}
                                                    onChange={this.handleInvoiceDate}
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row  pt-2 mt-4">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <b> Project code: </b>
                                            </div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control text-center"
                                                    value={this.props.poDetails.paymentTermDetailsByPoId.wbsCode ?
                                                        (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 2) == "ET" ?
                                                            (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 11) :
                                                            (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 6) : "NA"}
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.dataFullForSupplier && this.state.dataFullForSupplier.PaymentTypeId && this.state.dataFullForSupplier.PaymentTypeId != 3 ?
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <Switch onChange={(e) => this.handleSwitch(e)} checked={this.state.checkedSwitch} onColor="#86d3ff" onHandleColor="#2693e6" handleDiameter={30} uncheckedIcon={false} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" id="material-switch" />
                                                </div>
                                                <div className="col-md-10">
                                                    {this.state.checkedSwitch ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>}
                                                </div>
                                            </div>
                                        </div>
                                        : null}
                                </div>
                                <div className="row pt-2 mt-4">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <b>Invoice Amount: </b>
                                            </div>
                                            <div className="col-md-5">
                                                <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                                                    // value={this.state.InvoiceAmount ? this.state.InvoiceAmount : 0}
                                                    value={this.state.InvoiceAmount ? this.state.InvoiceAmount : this.state.dataFullForSupplier && this.state.dataFullForSupplier.InvoiceAmount ? this.state.dataFullForSupplier.InvoiceAmount : ""}
                                                    onValueChange={(value) => this.InvoiceAmountInput(value)}
                                                // disabled={this.state.dataFullForSupplier.PaymentTypeId == 3 ? true : false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row pt-2 mt-4">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <b> Currency: </b>
                                            </div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control text-center"
                                                    value={this.props.poDetails.paymentTermDetailsByPoId.Currency ? this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() : "NA"}
                                                ></input>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer ">
                                <div>
                                    <button className="btn2 btn-sms1 mt-2 rounded-pill ml-4 float-right" onClick={() => this.InsertInvoiceDetailsForSupplier(this.state.dataFullForSupplier)} type="submit"> Submit </button>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.AcceptmodalForSupplier}>{" "}Cancel{" "}</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>

                {/* ---- Accept Modal For Supplier End-------- */}
                {/* ----Accept Modal For Supplier Partial Start----- */}

                <Modal isOpen={this.state.AcceptmodalForSupplierPartial} className="modal-lg">
                    <div
                        className={
                            "modal-bg" + (this.state.AcceptmodalForSupplierPartial === "false" ? "open" : "")
                        }
                    >
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div>
                                    <h4> Invoice Details </h4>
                                </div>
                                <button
                                    type="button"
                                    className="close"
                                    aria-label="Close"
                                    onClick={this.AcceptmodalForSupplierPartial}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div>
                            <ModalBody Style="modal-body">
                                <div className="row pt-2 mt-4">
                                    <div className="col-md-6 ">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <b> Invoice No: </b>
                                            </div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    value={this.state.InvoiceNo}
                                                    onChange={this.InvoiceNoInput}
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <b>Invoice Date:</b>
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    type="date"
                                                    max={formatDate(new Date())}
                                                    className="form-control text-center"
                                                    value={this.state.InvoiceDate}
                                                    onChange={this.handleInvoiceDate}
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row  pt-2 mt-4">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <b> Project code: </b>
                                            </div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control text-center"
                                                    value={this.props.poDetails.paymentTermDetailsByPoId.wbsCode ?
                                                        (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 2) == "ET" ?
                                                            (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 11) :
                                                            (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 6) : "NA"}
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-2">
                                                <Switch onChange={(e) => this.handleSwitch(e)} checked={this.state.checkedSwitch} onColor="#86d3ff" onHandleColor="#2693e6" handleDiameter={30} uncheckedIcon={false} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" id="material-switch" />
                                            </div>
                                            <div className="col-md-10">
                                                {this.state.checkedSwitch ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row pt-2 mt-4">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <b>Invoice Amount: </b>
                                            </div>
                                            <div className="col-md-5">
                                                <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                                                    value={this.state.InvoiceAmount ? this.state.InvoiceAmount : 0}
                                                    onValueChange={(value) => this.InvoiceAmountInput(value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row pt-2 mt-4">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <b> Currency: </b>
                                            </div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control text-center"
                                                    value={this.props.poDetails.paymentTermDetailsByPoId.Currency ? this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() : "NA"}
                                                ></input>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer ">
                                <div>
                                    <button className="btn2 btn-sms1 mt-2 rounded-pill ml-4 float-right" onClick={() => this.InsertInvoiceDetailsForSupplierPartial(this.state.dataFullForSupplier)} type="submit"> Submit </button>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.AcceptmodalForSupplierPartial}>{" "}Cancel{" "}</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>

                {/* ---- Accept Modal Supplier Partial End-------- */}
                {/* Add Drawing MODAL starts */}
                <Modal isOpen={this.state.addDrawingmodal} >
                    <div className={"modal-bg" + (this.state.addDrawingmodal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Add Drawing </h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={() => { this.addDrawingInputmodal() }} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-5"><b>Document Name :</b></div>
                                    <div className="col-md-7">
                                        <input type="text" className="form-control" value={this.state.documentName} onChange={(e) => this.setDocumentName(e)}></input>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDrawingInputmodal() }} type="submit">Cancel</button>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDrawingtoList() }} type="submit">Add Drawing</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                {/* Add Drawing MODAL ENDS */}
                {/* Add Document MODAL starts */}
                <Modal isOpen={this.state.addDocumentmodal} >
                    <div className={"modal-bg" + (this.state.addDocumentmodal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Add Documents </h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={() => { this.addDocumentmodal() }} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-5"><b>Document Name :</b></div>
                                    <div className="col-md-7">
                                        <input type="text" className="form-control" value={this.state.transmittleDocumentName} onChange={(e) => this.setTransmittleDocumentName(e)}></input>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDocumentmodal() }} type="submit">Cancel</button>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDocumentstoList(this.state.indicator) }} type="submit">Add Document</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                {/* Add Document MODAL ENDS */}
                {/* Link GRN Modal */}
                <Modal isOpen={this.state.GRNModal} className="modal-lg">
                    <div className={"modal-bg" + (this.state.GRNModal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header  ">
                                {this.state.infoValGRN == 1 ? <div><h4 >Assigned GRN Details :</h4></div> : <div><h4 >GRN Link With Invoice :</h4></div>}
                                <button type="button" className="close" aria-label="Close" onClick={() => this.GRNModal()} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div >
                            <ModalBody Style="modal-body modalbodysWideBudget ">
                                {this.state.infoValGRN == 1 ?
                                    <div className="row  mt-4 align">
                                        <div className="col ">
                                            <table border="1" className="table5 table" >
                                                <thead>
                                                    <tr className="headerbar ">
                                                        <th>PO LineItem No.</th>
                                                        <th>Service LineItem No.</th>
                                                        <th>GRN No.</th>
                                                        <th>SRN No.</th>
                                                        <th>GRN Qty.</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.GRNTableData && this.state.GRNTableData.map((data, index) =>
                                                        <tr key={index} className="rows headeralign">
                                                            <td>{data.POLineItemSAPCode}</td>
                                                            <td>{data.ServiceLineItemNumber ? data.ServiceLineItemNumber : ""}</td>
                                                            <td>{data.GRNDocNo}</td>
                                                            <td>{data.SRN ? data.SRN : ""}</td>
                                                            <td>{data.GRNQty}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    :
                                    <div className="col-md-12 pt-2">
                                        <div className="row ">
                                            <div className="col-md-4 pt-2 " >
                                                <b>GRN Link With Invoice :</b>
                                            </div>
                                            <div className="col-md-6 pt-2 " >
                                                <Select maxMenuHeight={500} placeholder="GRNS" value={this.state.GRNDocNo} styles={customStyles} options={this.state.GRNDropDownData} onChange={(e) => this.handleSelectGRN(e)} />
                                            </div>
                                        </div>
                                        <div className="row  mt-4 align">
                                            <div className="col ">
                                                <table border="1" className="table5 table" >
                                                    <thead>
                                                        <tr className="headerbar ">
                                                            <th>PO LineItem No.</th>
                                                            <th>Service LineItem No.</th>
                                                            <th>GRN No.</th>
                                                            <th>SRN No.</th>
                                                            <th>GRN Qty.</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.GRNTableData && this.state.GRNTableData.map((data, index) =>
                                                            <tr key={index} className="rows headeralign">
                                                                <td>{data.POLineItemSAPCode}</td>
                                                                <td>{data.ServiceLineItemNumber ? data.ServiceLineItemNumber : ""}</td>
                                                                <td>{data.GRNDocNo}</td>
                                                                <td>{data.SRN ? data.SRN : ""}</td>
                                                                <td>{data.GRNQty}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer ">
                                <div>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={() => this.GRNModal()}> Close </button>
                                    {this.state.infoValGRN != 1 ?
                                        <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={() => this.SubmitGRNData()}> Submit </button>
                                        : null}
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                {/* Link GRN Modal END */}

                <div className="row mr-2 ml-2">
                    <div className="col-md-6 header"><b>Purchase Order Details :</b></div>
                    {/* ---- For SMS teams---- */}

                    {roles[15] && this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentStatus == null ? (<>
                        <div className="col-md-6 mt-2 ">
                            {/* {this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 1 || this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 5 ?
                                <button className="btn2 btn-sms1 rounded-pill mt-2 float-right " type="submit" onClick={() => { this.approvePOAcceptanceDocument(this.props.poDetails.paymentTermDetailsByPoId.poId, 1, 1) }}> Waive Off For Payment </button>
                                : null}
                            {this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 1 || this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 5 ?
                                <button className="btn2 btn-sms1 rounded-pill mt-2 float-right " type="submit" onClick={() => { this.approvePOAcceptanceDocument(this.props.poDetails.paymentTermDetailsByPoId.poId, 1, 2) }}> Waive Off For Execution </button>
                                : null} */}
                            {console.log(this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus, "this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus")}
                            {(this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus === 2 || this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus === 5) && this.props.poDetails.paymentTermDetailsByPoId.Currency !== 'INR' ?
                                <button className="btn2 btn-sms1 rounded-pill mt-2 float-right" type="submit" onClick={() => this.ReviseModalPopUp(1)}> Upload & Approve Acceptance </button>
                                : null}
                            {this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId ?
                                this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 3 ?
                                    <>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 float-right" type="submit" onClick={() => { this.approvePOAcceptanceDocument(this.props.poDetails.paymentTermDetailsByPoId.poId, 1) }}> Approve </button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 float-right " type="submit" onClick={() => this.ReviseModalPopUp()}> Revise </button>
                                    </>
                                    :
                                    this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 2 || this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 7 ?
                                        null
                                        :
                                        <>
                                            <button className="btn2 btn-sms1 rounded-pill mt-2 float-right" type="submit" onClick={() => this.ReviseModalPopUp(1)}> Upload & Approve Acceptance </button>
                                            <button className="btn2 btn-sms1 rounded-pill mt-2 float-right " type="submit" onClick={() => this.ReviseModalPopUp()}> Revise </button>
                                        </>
                                : null
                            }
                        </div>
                    </>)
                        : roles[15] && this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentStatus !== null ? (<>
                            <div className="col-md-6 mt-2 ">
                                {this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 1 || this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 5 ?
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 float-right " type="submit" onClick={() => this.ReviseModalPopUp(1)}> Upload & Approve Acceptance</button>
                                    : null}
                                {this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId ?
                                    this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 3 ?
                                        <>
                                            <button className="btn2 btn-sms1 rounded-pill mt-2 float-right" type="submit" onClick={() => { this.approvePOAcceptanceDocument(this.props.poDetails.paymentTermDetailsByPoId.poId, 1) }}> Approve </button>
                                            <button className="btn2 btn-sms1 rounded-pill mt-2 float-right " type="submit" onClick={() => this.ReviseModalPopUp()}> Revise </button>
                                        </>
                                        :
                                        this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 6 ?
                                            <>
                                                <button className="btn2 btn-sms1 rounded-pill mt-2 float-right" type="submit" onClick={() => this.ReviseModalPopUp(1)}> Upload & Approve Acceptance </button>
                                                <button className="btn2 btn-sms1 rounded-pill mt-2 float-right " type="submit" onClick={() => this.ReviseModalPopUp()}> Revise </button>
                                            </>
                                            :
                                            null
                                    : null
                                }
                            </div>
                        </>)

                            : null}
                </div>
                <div className="pb-4 p-2 ">
                    <div>
                        <div className="row">
                            <div className="col-md-6 pt-2 " >
                                <div className="row">
                                    <div className="col" ><b>PO No. :</b></div>
                                    <div className="col">{this.props.poDetails.paymentTermDetailsByPoId.poSapCode}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col" ><b>PO Date :</b></div>
                                    <div className="col ">{dateFormater(this.props.poDetails.paymentTermDetailsByPoId.poDate)}</div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 pt-2 " >
                                <div className="row">
                                    <div className="col" ><b>PO Amount :</b></div>
                                    <div className="col">{this.props.poDetails.paymentTermDetailsByPoId.Currency + " " + numberWithCommas(this.state.PoAmount)}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col" ><b>Supplier Name :</b></div>
                                    <div className="col ">{this.props.poDetails.paymentTermDetailsByPoId.vendorName}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-md-6 pt-2 " >
                                <div className="row">
                                    <div className="col" ><b>Location :</b></div>
                                    <div className="col">{this.props.poDetails.paymentTermDetailsByPoId.location}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col" ><b>Payment Term :</b></div>
                                    <div className="col ">{this.props.poDetails.paymentTermDetailsByPoId.paymentTermCode}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 pt-2 " >
                                <div className="row">
                                    <div className="col" ><b>PO Document :</b></div>
                                    <div className="col">
                                        {this.props.poDetails.paymentTermDetailsByPoId.poDetailsDocumentId ?
                                            <>
                                                <FontAwesomeIcon className={"mr-3"} icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(this.props.poDetails.paymentTermDetailsByPoId.poDetailsDocumentId)} />
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.poDetails.paymentTermDetailsByPoId.poDetailsDocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon icon={"file-download"} color={"black"} title={"Download"} size="lg" />
                                                </a>
                                                <FontAwesomeIcon className="ml-3" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClickPoComments(this.props.poDetails.paymentTermDetailsByPoId.poId, this.props.poDetails.paymentTermDetailsByPoId.poDetailsDocumentId)} />
                                            </>
                                            :
                                            <FontAwesomeIcon icon={"stopwatch"} color={"grey"} title={"Awaiting for Upload"} size="lg" />
                                        }
                                    </div>
                                </div>
                                <div className="row pt-2">
                                    <div className="col" ><b>PO Acceptance Status :</b></div>
                                    <div className="col">
                                        {this.props.poDetails.paymentTermDetailsByPoId.isWaivedOff == 1 ? "PO is Clear for Payment by Waive Off" : this.props.poDetails.paymentTermDetailsByPoId.isWaivedOff == 2 ? "PO is Clear for Execution by Waive Off" : this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatusName}
                                    </div>
                                </div>
                                <div className="row pt-2">
                                    <div className="col" ><b>Claimed Planner Name :</b></div>
                                    <div className="col">
                                        {this.props.poDetails.paymentTermDetailsByPoId.claimBy == null ? "To be claimed" : this.props.poDetails.paymentTermDetailsByPoId.claimBy}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col" ><b>PO Acceptance Document :</b></div>
                                    <div className="col">
                                        {this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId ?
                                            <>
                                                <FontAwesomeIcon className={"mr-3"} icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId)} />
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon icon={"file-download"} color={"black"} title={"Download"} size="lg" />
                                                </a>
                                                <FontAwesomeIcon className="ml-3" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClickPoComments(this.props.poDetails.paymentTermDetailsByPoId.poId, this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId)} />
                                            </>
                                            :
                                            <FontAwesomeIcon icon={"stopwatch"} color={"grey"} title={"Awaiting for Upload"} size="lg" />
                                        }
                                    </div>
                                </div>
                                <div className="row pt-2">
                                    <div className="col" ><b>Claimed Expeditor Name:</b></div>
                                    <div className="col">
                                        {this.state.claimedExpeditorId ? this.state.claimedExpeditor : "To be claimed"}
                                    </div>
                                </div>
                                <div className="row pt-2">
                                    <div className="col" ><b>Vendor Email:</b></div>
                                    <div className="col">
                                        {this.props.poDetails.paymentTermDetailsByPoId.vendorEmail}
                                        {roles[15] ?
                                            <div className='row pt-2 pr-4'>
                                                <div className='col'>
                                                    <div className='input-group'>
                                                        <input type="text" className='form-control pt-2' onChange={(e) => this.handleEmail(e)} value={this.state.AdditionalEmailId} />
                                                        <Button title='Add' variant="outline-primary" onClick={() => this.AddEmailId(this.props.poDetails.paymentTermDetailsByPoId.vendorEmail)}>Add</Button>
                                                    </div>
                                                </div>
                                            </div>
                                            : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr></hr>
                <div className="row-md-8 pr-4 pt-2">
                    <div className="row">
                        <div className="col-md-3">
                            <h5>PO Annexure (By SMS) : </h5>
                        </div>
                        {roles[15] || (roles[7]) ?
                            <div className="col-md-1">
                                <FontAwesomeIcon className="align-middle" icon={"plus-circle"} title="Add More Documents" color={"blue"} size="lg" onClick={() => this.addDocumentmodal(1)} />
                            </div>
                            : null}
                    </div>
                    <TableComp cols={TransmittalTableConstants()} data={this.state.PoAnnexure} />
                </div>
                <div className="row-md-8 pr-4 pt-2">
                    <div className="row">
                        <div className="col-md-3">
                            <h5>Drawing Transmittal (By SMS): </h5>
                        </div>
                        {roles[15] || (roles[7]) ?
                            <div className="col-md-1">
                                <FontAwesomeIcon className="align-middle" icon={"plus-circle"} title="Add More Documents" color={"blue"} size="lg" onClick={() => this.addDocumentmodal(2)} />
                            </div>
                            : null}
                    </div>
                    <TableComp cols={TransmittalTableConstantsDrawing()} data={this.state.DrawingTransmittal} />
                </div>
                <hr></hr>
                {/* document section */}
                <div className="pt-4">
                    <h4>All Documents :</h4>
                    {this.state.DraftDocuments && this.state.DraftDocuments.length > 0 && this.state.DraftDocuments.map((item, index) =>
                        <Accordion key={index} defaultActiveKey='0'>
                            <Card>
                                <Accordion.Toggle as={"h6"} className="accordion-background mb-0 pb-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(20)} onClick={() => this.setState({ activeEventKey: JSON.stringify(20) })}>
                                    <div className=" row pl-4 pr-4">
                                        <div className="col pt-2">
                                            Draft Documents{item.Counter > 0 ? " - " + (item.Counter + 1) : " - 1"}
                                            <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                        </div>
                                        <div className="col mt-2">
                                            {(!roles[5]) && item.Documents.map((elem, index) =>
                                                <div key={index}>
                                                    {elem.ActingDeptGroupId != null ?
                                                        this.state.approvalDetailsByCPMorTPM.find((data) => data.AdvanceStageDocumentMappingId == elem.AdvanceStageDocumentMappingId && data.approvalStatus == 1 && data.ActedGroupId == elem.ActingDeptGroupId) ?
                                                            <div className="approvalcircle float-right" style={{ backgroundColor: "#A9FF8A", opacity: "0.5", borderColor: "#080B06" }}>
                                                                <p className="text-center pt-2 pl-2 mt-1" style={{ fontSize: "12px" }}>{elem.ShortDeptName}</p>
                                                            </div>
                                                            : this.state.approvalDetailsByCPMorTPM.find((data) => data.AdvanceStageDocumentMappingId == elem.AdvanceStageDocumentMappingId && data.approvalStatus == 3 && data.ActedGroupId == elem.ActingDeptGroupId) ?
                                                                <div className="approvalcircle float-right" style={{ backgroundColor: "#FFBC8A", opacity: "0.7", borderColor: "#f4700e" }}>
                                                                    <p className="text-center pt-2 pl-2 mt-1" style={{ fontSize: "12px" }}>{elem.ShortDeptName}</p>
                                                                </div>
                                                                :
                                                                <div className="approvalcircle float-right" style={{ backgroundColor: "#FFFFFF", opacity: "0.6", borderColor: "#a2a09e" }}>
                                                                    <p className="text-center pt-2 pl-2 mt-1" style={{ fontSize: "12px" }}>{elem.ShortDeptName}</p>
                                                                </div>
                                                        : null
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Accordion.Toggle>
                            </Card>
                            <Accordion.Collapse eventKey={JSON.stringify(20)}>
                                <Card.Body>
                                    <div className="row row-md-8 pr-4">
                                        {(roles[5] || roles[7]) && (!item.Documents.find(el => el.AdvanceStageDocumentMappingId) || item.Documents.find(el => el.approvalStatus == 0)) ?
                                            <div className="col-12">
                                                <button className="float-right btn2 btn-sms1 rounded-pill" onClick={() => this.submitInvoiceDocuments(item, 'Draft Documents')}>Submit Draft Documents</button>
                                            </div>
                                            : null}
                                        <div className="col-12 ">
                                            <div className="row  headerbar" style={{ backgroundColor: "#0989cb", color: "white" }}>
                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar">Document Type</div>
                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">Acting Department</div>
                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">Submitted On</div>
                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">Acted On</div>
                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar">Actions</div>
                                            </div>
                                            {item.Documents.map((element, Index) =>
                                                <div key={Index} className={Index % 2 == 0 ? 'row border ' : 'row  background '} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                                                    <div className="col-md-3 pt-2 pb-2 borderheaderbar text-left">{element.DocumentTypeName}</div>
                                                    {
                                                        (roles[5]) ?
                                                            <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">SMS Team</div>
                                                            :
                                                            element.DocumentTypeId && element.DocumentId && element.approvalStatus == 3 ?
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">{this.props.poDetails.paymentTermDetailsByPoId.vendorName}</div>
                                                                :
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">{element.GroupName}</div>
                                                    }
                                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center">{element.CreatedOn ? dateFormater(element.CreatedOn) : null}</div>
                                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center">{element.approvedOn ? dateFormater(element.approvedOn) : null}</div>
                                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center">
                                                        {(roles[5] || roles[7]) && element.DocumentId === null && element.isWaivedOff !== 2 ?
                                                            <>
                                                                <div className="view-button justify-content-between row">
                                                                    <div className="col dark">
                                                                        <input type="file" className="form-control-file" style={{ width: "200%" }} onChange={(e) => { this.handleFileInput(e, element) }} id="exampleFormControlFile1" />
                                                                    </div>
                                                                    <div className="col-md-4" style={{ left: "100px" }}>
                                                                        <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={(e) => { this.onclickUpload(element, 0, 0, "Draft Documents") }} color={"black"} title={"Upload File"} size="lg" />
                                                                        {element.DocumentTypeId in this.props.poDetails.poDetailsForAdvance && element.approvalStatus == 3 ?
                                                                            <>
                                                                                <FontAwesomeIcon className="align-middle mr-2" icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                <FontAwesomeIcon className="align-middle" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                            </>
                                                                            : null
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {element.approvalStatus == 3 ?
                                                                    <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                        {this.state.docStatus[element.approvalStatus]['title']}
                                                                    </span>
                                                                    : null}
                                                            </>
                                                            : element.DocumentId !== null && !roles[5] && (groups[element.ActingDeptGroupId] || (element.ActingDeptGroupId == 4 && (groups[2] || groups[27] || groups[28] || groups[29] || groups[30] || groups[31]))) && element.approvalStatus === 6 ?
                                                                <>
                                                                    <div className="row">
                                                                        <div className="col align-middle">
                                                                            <FontAwesomeIcon
                                                                                className="align-middle pr-2"
                                                                                icon={"code-branch"}
                                                                                color={"black"}
                                                                                title="Document Version"
                                                                                size="2x" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.DocumentId + "/download"} target="_blank" download>
                                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="Download" color={"black"} size="2x" />
                                                                            </a>
                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: element, qATemplateStageId: 1 }, true, 0, element.DocumentId, this.state.approvalStatus.approved)} />
                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: element, qATemplateStageId: 1 }, true, 0, element.DocumentId, this.state.approvalStatus.revise)} />
                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                        </div>
                                                                    </div>
                                                                    <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                        {this.state.docStatus[element.approvalStatus]['title']}
                                                                    </span>
                                                                </>
                                                                : element.DocumentId ?
                                                                    <>
                                                                        <div className="row align-middle">
                                                                            <div className="col align-middle">
                                                                                <FontAwesomeIcon
                                                                                    className="align-middle pr-2"
                                                                                    icon={"code-branch"}
                                                                                    color={"black"}
                                                                                    title="Document Version"
                                                                                    size="2x" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.DocumentId + "/download"} target="_blank" download>
                                                                                    <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                                                </a>
                                                                                <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                            </div>
                                                                        </div>
                                                                        <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                            {this.state.docStatus[element.approvalStatus]['title']}
                                                                        </span>
                                                                    </>
                                                                    : <FontAwesomeIcon icon={"stopwatch"} title="Awaiting upload from supplier" color={"grey"} size="lg" />}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Accordion>
                    )}
                    {this.state.paymentTermDocuments.map((item, index) =>
                        <div key={index}>
                            {((roles[5] || roles[7]) && (this.props.poDetails.paymentTermDetailsByPoId.paymentTermId === 5 || this.props.poDetails.paymentTermDetailsByPoId.poacceptanceStatus == 7) && (item.PaymentTypeId !== 3 || ((item.InvoiceId || (this.props.poDetails.paymentTermDetailsByPoId.paymentTermCode === "Y009" || this.props.poDetails.paymentTermDetailsByPoId.paymentTermCode === "Y026")) && (this.state.DraftDocuments.length === 0 || item.DraftDocumentApprovaStatus === 1)))) || (!roles[5] && !roles[7]) ?
                                <Accordion defaultActiveKey="10">
                                    <Card>
                                        <Accordion.Toggle as={"h6"} className="accordion-background mb-0 pb-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(index)} onClick={() => this.setState({ activeEventKey: JSON.stringify(index) })}>
                                            <div className=" row pl-4 pr-4">
                                                <div className="col pt-2">
                                                    {item.TypeFor != null ? `${item.PaymentType} Against ${item.TypeFor}` : item.PaymentType}{item.Counter > 0 ? " - " + (item.Counter + 1) : " - 1"}
                                                    <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                                </div>
                                                <div className="col pt-2">
                                                    {item.PaymentTypeId == 3 ? item.InvoiceAmount ? "For " + item.Currency + " " + numberWithCommas(item.InvoiceAmount) : '' : null}
                                                </div>
                                                {!roles[5] ?
                                                    <div className="col mt-2">
                                                        {item.ApprovalDepartments.filter((elem) => elem.ActingDeptGroupId == 19).length == 0 && item.PaymentTypeId == 2 ? this.state.approvalDetailsByCPMorTPM.find((data) => data.TypeFor == item.TypeFor && data.PaymentType == item.PaymentTypeId && data.approvalStatus == 1 && data.ActedGroupId == 19 && data.DocumentTypeId == 0) ?
                                                            <div className="float-right ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>PM</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            : <div className="float-right ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>PM</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            // : null
                                                            : null
                                                        }
                                                        {item.ApprovalDepartments.filter((data) => data.ActingDeptGroupId == 26).length == 0 && item.PaymentTypeId == 2 ? this.state.approvalDetailsByCPMorTPM.find((data) => data.TypeFor == item.TypeFor && data.PaymentType == item.PaymentTypeId && data.approvalStatus == 1 && data.ActedGroupId == 26 && data.DocumentTypeId == 0) ?
                                                            <div className="float-right ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>CM</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            : <div className="float-right ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>CM</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            // : null
                                                            : null
                                                        }
                                                        {item.ApprovalDepartments.filter((data) => data.ActingDeptGroupId == 7 ).length == 0 && item.PaymentTypeId != 2 ? this.state.approvalDetailsByCPMorTPM.find((data) => data.TypeFor == item.TypeFor && data.PaymentType == item.PaymentTypeId && data.approvalStatus == 1 && data.ActedGroupId == 7 && data.DocumentTypeId == 0) ?
                                                            <div className="float-right ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>EXP</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            : <div className="float-right ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>EXP</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                            : null
                                                        }
                                                        {item.ApprovalDepartments.map((elem, index) =>
                                                            <div key={index} className="float-right ml-1">
                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={Math.round((elem.ApprovedCount / elem.TotalApprovalCount) * 100)}>
                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>{elem.ShortDeptName}</div>
                                                                </CircularProgressbarWithChildren>
                                                            </div>
                                                        )}
                                                    </div>
                                                    : null}
                                            </div>
                                        </Accordion.Toggle>
                                    </Card>
                                    {/* {item.TypeFor!= null ? <h5 className="pl-2">{item.PaymentType} Against {item.TypeFor}</h5>
                                :<h5 className="pl-2">{item.PaymentType}</h5>} */}
                                    <Accordion.Collapse eventKey={JSON.stringify(index)}>
                                        <Card.Body>
                                             {item.Documents.filter((data) => data.ActingDeptGroupId == 19).length == 0 && item.PaymentTypeId == 2 && roles[12] && this.state.approvalDetailsByCPMorTPM.find((data) => data.approvalStatus != 0) && !this.state.approvalDetailsByCPMorTPM.find((data) => data.TypeFor == item.TypeFor && data.PaymentType == item.PaymentTypeId && data.approvalStatus == 1 && data.ActedGroupId == 19) ?
                                                <div className="row">
                                                    <div className="col">
                                                        {item.Documents.some(obj => (obj.approvalStatus === 6 || obj.approvalStatus === 1)) ?
                                                            <button className="float-right btn2 btn-sms1 mr-4 rounded-pill" onClick={() => this.approveByCPMandTPM(item, 19)}>Approve</button>
                                                            : ""}
                                                    </div>
                                                </div>
                                                : null}
                                            {item.Documents.filter((data) => data.ActingDeptGroupId == 26).length == 0 && item.PaymentTypeId == 2 && roles[19] && this.state.approvalDetailsByCPMorTPM.find((data) => data.approvalStatus != 0) && !this.state.approvalDetailsByCPMorTPM.find((data) => data.TypeFor == item.TypeFor && data.PaymentType == item.PaymentTypeId && data.approvalStatus == 1 && data.ActedGroupId == 26) ?
                                                <div className="row">
                                                    <div className="col">
                                                        {item.Documents.some(obj => (obj.approvalStatus === 6 || obj.approvalStatus === 1)) ?
                                                            <button className="float-right btn2 btn-sms1 mr-4 rounded-pill" onClick={() => this.approveByCPMandTPM(item, 26)}>Approve</button>
                                                            : ""}
                                                    </div>
                                                </div>
                                                : null} 
                                            {item.Documents.filter((data) => data.ActingDeptGroupId == 7 ).length == 0 && item.PaymentTypeId != 2 && roles[7] && this.state.approvalDetailsByCPMorTPM.find((data) => data.approvalStatus != 0) && !this.state.approvalDetailsByCPMorTPM.find((data) => data.TypeFor == item.TypeFor && data.PaymentType == item.PaymentTypeId && data.approvalStatus == 1 && data.ActedGroupId == 7) ?
                                                <div className="row">
                                                    <div className="col">
                                                        {item.Documents.some(obj => (obj.approvalStatus === 6 || obj.approvalStatus === 1)) ?
                                                            <button className="float-right btn2 btn-sms1 mr-4 rounded-pill" onClick={() => this.approveByCPMandTPM(item, 7)}>Approve</button>
                                                            : ""}
                                                    </div>
                                                </div>
                                                : null}  
                                            <div className="row row-md-8 pr-4">
                                                {(roles[5] || (roles[7])) && (!item.Documents.find(el => el.AdvanceStageDocumentMappingId) || item.Documents.find(el => el.approvalStatus == 0 && el.PaymentTypeId == item.PaymentTypeId && el.TypeFor == item.TypeFor)) ?
                                                    <div className="col-12">
                                                        <button className="float-right btn2 btn-sms1 rounded-pill" onClick={() => this.submitInvoiceDocuments(item)}>Submit Invoice</button>
                                                    </div>
                                                    : null}
                                                <div className="col-12 ">
                                                    <div className="row  headerbar" style={{ backgroundColor: "#0989cb", color: "white" }}>
                                                        <div className="col-md-3 pt-2 pb-2 borderheaderbar">Document Type</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Acting Department</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Submitted On</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Acted On</div>
                                                        <div className="col-md-3 pt-2 pb-2 borderheaderbar">Actions</div>
                                                    </div>

                                                    {/* {console.log(item, "IIKIKKI")} */}
                                                    {item.Documents.map((element, Index) =>
                                                        <div key={Index} className={Index % 2 == 0 ? 'row border ' : 'row  background '}
                                                            // onClick={() => this.togglebutton(Index)} 
                                                            data-toggle="collapse" data-target={`.multi-collapse${Index}`}>

                                                            <div className="col-md-3 pt-2 pb-2 borderheaderbar text-left">{`${element.DocumentTypeName} (${element.Amount}${element.AmountTypeName})`}</div>
                                                            {
                                                                (roles[5]) ?
                                                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">SMS Team2</div>
                                                                    :
                                                                    element.DocumentTypeId && element.DocumentId && element.approvalStatus == 3 ?
                                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">{this.props.poDetails.paymentTermDetailsByPoId.vendorName}</div>
                                                                        :
                                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">{element.GroupName}</div>
                                                            }
                                                            {/* <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{JSON.stringify(this.props.poDetails.poDetailsForAdvance[element.DocumentTypeId])}</div> */}
                                                            <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center">{(element.DocumentTypeName.includes('Proforma Invoice') && element.Summited_ON )?  dateFormater(element.Summited_ON):  element.CreatedOn ? dateFormater(element.CreatedOn) : null}</div>
                                                            <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center">{element.approvedOn ? dateFormater(element.approvedOn) : null}</div>
                                                            <div className="col-md-3 pt-2 pb-2 text-center">
                                                                {/* {element.DocumentId && element.approvalStatus == 0 && !roles[5] ? */}

                                                                {element.DocumentId == null || ((roles[5] || ((roles[7]) && !groups[element.ActingDeptGroupId])) && element.DocumentId && (element.approvalStatus == 3 || element.approvalStatus == 2 || element.approvalStatus == 0 || element.approvalStatus == 6)) ?
                                                                    element.DocumentTypeId == 40 && this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId != null ?
                                                                        <div className="row">
                                                                            <div className="col align-middle">
                                                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId + "/download"} target="_blank" download>
                                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        // console.log("<MNBVC",item)
                                                                        (roles[5] || (roles[7])) && element.isWaivedOff !== 2 ?
                                                                            <>
                                                                                <div className="view-button justify-content-between row">
                                                                                    <div className="col dark">
                                                                                        <input type="file" ref={(ref) => { this.documentRef.current[element.DocumentTypeId] = ref; return true; }} className="form-control-file"
                                                                                            onChange={(e) => { this.handleFileInput(e, element) }} id="exampleFormControlFile1" />
                                                                                    </div>
                                                                                    <div className="col mr-2">
                                                                                        {element.DocumentTypeId == 84 || element.DocumentTypeId == 73 || element.DocumentTypeId == 52 || element.DocumentTypeId == 36 || element.DocumentTypeId == 41 || element.DocumentTypeId == 46 || element.DocumentTypeId == 101 || element.DocumentTypeId == 110 || element.DocumentTypeId == 111 || element.DocumentTypeId == 112 || element.DocumentTypeId == 113 || element.DocumentTypeId == 114 || element.DocumentTypeId == 115 || element.DocumentTypeId == 118 || element.DocumentTypeId == 119 ?
                                                                                            <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={(e) => { this.AcceptmodalForSupplier(element) }} color={"black"} title={"Upload File"} size="lg" />
                                                                                            : (element.DocumentTypeId == 70 || element.DocumentTypeId == 43)  ?
                                                                                                (this.state.BgDraftDocTableData && this.state.BgDraftDocTableData.length>0 && this.state.BgDraftDocTableData.some(item => 
                                                                                                        item.PurchaseOrderID == this.state.poID && item.Status == 1 && item.BgType == (element.DocumentTypeId == 70? "PBG": "ABG")
                                                                                                )? <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={() => this.BGModal(element)} color={"black"} title={"Upload File"} size="lg" />: <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} color={"grey"} cursor="not-allowed" disabled title={"First Upload and get approval on draft BG"} size="lg" />)
                                                                                                : <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={(e) => { this.onclickUpload(element) }} color={"black"} title={"Upload File"} size="lg" />
                                                                                        }
                                                                                        {element.DocumentTypeId in this.props.poDetails.poDetailsForAdvance && element.approvalStatus == 3 ?
                                                                                            <>
                                                                                                <FontAwesomeIcon className="align-middle mr-2" icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                                <FontAwesomeIcon className="align-middle" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                                            </>
                                                                                            : null
                                                                                        }
                                                                                        {
                                                                                            element.DocumentId &&
                                                                                            <>
                                                                                                <FontAwesomeIcon
                                                                                                    className="align-middle pr-2"
                                                                                                    icon={"code-branch"}
                                                                                                    color={"black"}
                                                                                                    title="Document Version"
                                                                                                    cursor="pointer"
                                                                                                    size="2x" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.DocumentId + "/download"} target="_blank" download>
                                                                                                    <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                                                                </a>
                                                                                                <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" cursor="pointer" onClick={() => this.rowClick(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                                            </>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                {element.DocumentTypeId in this.props.poDetails.poDetailsForAdvance ?
                                                                                    <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                                        {this.state.docStatus[element.approvalStatus]['title']}
                                                                                    </span>
                                                                                    : null}
                                                                            </>
                                                                            : (element.DocumentTypeId in this.props.poDetails.poDetailsForAdvance && (element.approvalStatus == 3 || element.approvalStatus == 2)) ?
                                                                                <>
                                                                                    <div className="row align-middle">
                                                                                        <div className="col align-middle">
                                                                                            <FontAwesomeIcon
                                                                                                className="align-middle pr-2"
                                                                                                icon={"code-branch"}
                                                                                                color={"black"}
                                                                                                title="Document Version"
                                                                                                size="2x" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.DocumentId + "/download"} target="_blank" download>
                                                                                                <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                                                            </a>
                                                                                            <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                                            {element.DocumentTypeId == 70 || element.DocumentTypeId == 43 ?
                                                                                                <FontAwesomeIcon className="align-middle" icon={"info-circle"} color={"blue"} title="info" size="lg" cursor="pointer" onClick={() => this.addAndUpdateBGModal(element)} />
                                                                                                : null}
                                                                                        </div>
                                                                                    </div>
                                                                                    <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                                        {this.state.docStatus[element.approvalStatus]['title']}
                                                                                    </span>
                                                                                </>
                                                                                :
                                                                                <FontAwesomeIcon icon={"stopwatch"} title="Awaiting upload from supplier" color={"grey"} size="lg" />

                                                                    :

                                                                    element.DocumentId && element.approvalStatus == 6 && !roles[5] && (groups[element.ActingDeptGroupId] || (element.ActingDeptGroupId == 4 && (groups[2] || groups[27] || groups[28] || groups[29] || groups[30] || groups[31]))) ?
                                                                        (
                                                                            <>
                                                                                <div className="row">
                                                                                    <div className="col align-middle">
                                                                                        <FontAwesomeIcon
                                                                                            className="align-middle pr-2"
                                                                                            icon={"code-branch"}
                                                                                            color={"black"}
                                                                                            title="Document Version"
                                                                                            cursor="pointer"
                                                                                            size="2x" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                        <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.DocumentId + "/download"} target="_blank" download>
                                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="Download" color={"black"} size="2x" />
                                                                                        </a>

                                                                                        {roles[8] == true && groups[8] == true && ((element.DocumentTypeId == 84 || element.DocumentTypeId == 73 || element.DocumentTypeId == 52 || element.DocumentTypeId == 36 || element.DocumentTypeId == 41 || element.DocumentTypeId == 46 || element.DocumentTypeId == 101 || element.DocumentTypeId == 110 || element.DocumentTypeId == 111 || element.DocumentTypeId == 112 || element.DocumentTypeId == 113 || element.DocumentTypeId == 114 || element.DocumentTypeId == 115 || element.DocumentTypeId == 118 || element.DocumentTypeId == 119)) ?
                                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" cursor="pointer" size="2x" onClick={() => this.Acceptmodal(element.DocumentTypeId, element.DocumentTypeName, element, element.DocumentId)} />
                                                                                            : <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" cursor="pointer" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: element, qATemplateStageId: 1 }, true, 0, element.DocumentId, this.state.approvalStatus.approved)} />
                                                                                        }

                                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" cursor="pointer" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: element, qATemplateStageId: 1 }, true, 0, element.DocumentId, this.state.approvalStatus.revise)} />
                                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" cursor="pointer" onClick={() => this.rowClick(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                                        {element.DocumentTypeId == 70 || element.DocumentTypeId == 43 ?
                                                                                            <FontAwesomeIcon className="align-middle mt-2" icon={"info-circle"} color={"blue"} title="info" size="lg" cursor="pointer" onClick={() => this.addAndUpdateBGModal(element)} />
                                                                                            : null}
                                                                                    </div>
                                                                                </div>
                                                                                <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                                    {this.state.docStatus[element.approvalStatus]['title']}
                                                                                </span>
                                                                            </>

                                                                        )
                                                                        :
                                                                        element.DocumentId ?
                                                                            (
                                                                                <>
                                                                                    <div className="row align-middle">
                                                                                        <div className="col align-middle">
                                                                                            <FontAwesomeIcon
                                                                                                className="align-middle pr-2"
                                                                                                icon={"code-branch"}
                                                                                                color={"black"}
                                                                                                title="Document Version"
                                                                                                cursor="pointer"
                                                                                                size="2x" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.DocumentId + "/download"} target="_blank" download>
                                                                                                <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                                                            </a>
                                                                                            <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" cursor="pointer" onClick={() => this.rowClick(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                                            {!roles[5] && (element.DocumentTypeId == 70 || element.DocumentTypeId == 43) && element.BGListDetailsId != null ?
                                                                                                <FontAwesomeIcon className="align-middle" icon={"info-circle"} color={"blue"} title="info" size="lg" cursor="pointer" onClick={() => this.addAndUpdateBGModal(element)} />
                                                                                                : groups[9] && element.BGListDetailsId === null && (element.DocumentTypeId == 70 || element.DocumentTypeId == 43) ?
                                                                                                    <FontAwesomeIcon className="align-middle" icon={"plus-circle"} color={"blue"} title="info" size="lg" cursor="pointer" onClick={() => this.BGModalForPreUploadFiles(element, "Pre-Upload-files")} />
                                                                                                    : null}
                                                                                        </div>
                                                                                    </div>
                                                                                    <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                                        {this.state.docStatus[element.approvalStatus]['title']}
                                                                                    </span>
                                                                                </>
                                                                            )
                                                                            : null
                                                                }
                                                                { element.DocumentId && roles[5] == true && element.BGListDetailsId && element.DocumentTypeName.includes("Bank") ?
                                                                <>
                                                                   <FontAwesomeIcon className="align-middle"  icon="info-circle" onClick={() => this.OpenInFoModal(element)} cursor="pointer" title="info" size="lg" color='#000' />
                                                                   <FontAwesomeIcon className="align-middle ml-1" icon="arrow-circle-right" color={"green"} title="Request For BG" size="lg" cursor="pointer" onClick={() => {this.requestBGRequest(element)}} />
                                                                </>
                                                                :null}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {!roles[5] && item.PaymentTypeId == 3 && item.InvoiceId != null && item.Documents.filter(data => !data.AdvanceStageDocumentMappingId && (data.DocumentTypeId == 38 || data.DocumentTypeId == 41 || data.DocumentTypeId == 46 || data.DocumentTypeId == 52 || data.DocumentTypeId == 37 || data.DocumentTypeId == 36)).length == 0 && this.state.GRNbyPOId.length > 0 ?
                                                        (
                                                            <div className='row border '>
                                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar text-left">GRN</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">TPM</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center">{this.state.GRNbyPOId.find(data => data.InvoiceId == item.InvoiceId) ? this.state.GRNbyPOId.find(data => data.InvoiceId == item.InvoiceId).SubmissionDate ? dateFormater(this.state.GRNbyPOId.find(data => data.InvoiceId == item.InvoiceId).SubmissionDate) : "" : ""}</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center"></div>
                                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar text-center">
                                                                    {roles[12] && item.GRN.length == 0 ?
                                                                        <div className="view-button justify-content-between row">
                                                                            <div className="col dark">
                                                                                <input type="file" className="form-control-file" style={{ width: "69%" }} onChange={(e) => { this.handleFileInput(e, { DocumentTypeId: 122 }) }} id="exampleFormControlFile1" />
                                                                            </div>
                                                                            <div className="col-md-4 mr-2">
                                                                                <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={() => this.GRNSubmit(item)} color={"black"} title={"Upload File"} size="lg" />
                                                                            </div>
                                                                        </div>
                                                                        : item.GRN.length > 0 ?
                                                                            <>
                                                                                <div className="row align-middle">
                                                                                    <div className="col align-middle">
                                                                                        <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.state.GRNbyPOId.find(elem => elem.InvoiceId == item.InvoiceId).GRNDocumentId + "/download"} target="_blank" download>
                                                                                            <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                                                        </a>
                                                                                        <FontAwesomeIcon className="ml-2" icon={"info-circle"} title="info" color={"black"} size="lg" onClick={() => this.GRNinfo(1, item.GRN)} />                                                                                    </div>
                                                                                </div>
                                                                                <span className={"badge badge-warning"}>Document Submitted</span>
                                                                            </>

                                                                            : <FontAwesomeIcon icon={"stopwatch"} title="Awaiting for upload" color={"black"} size="lg" />
                                                                    }
                                                                </div>
                                                            </div>
                                                        )

                                                        : null}

                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Accordion>
                                : null
                            }
                        </div>

                    )}
                    {this.props.poDetails && this.props.poDetails.paymentTermDocuments && this.props.poDetails.paymentTermDocuments.recordsets && this.props.poDetails.paymentTermDocuments.recordsets[3].length > 0 ?
                        <>
                            {this.state.paymentTermDocumentsPartial.map((item, index) =>
                                <Accordion key={index} defaultActiveKey="20">
                                    {item.Documents.length > 0 ?
                                        <>
                                            <Card>
                                                <Accordion.Toggle as={"h6"} className="accordion-background mb-0 pb-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(index)} onClick={() => this.setState({ activeEventKey: JSON.stringify(index) })}>
                                                    <div className=" row pl-4 pr-4">
                                                        <div className="col pt-2">
                                                            {item.TypeFor != null ? `${item.PaymentType} Against ${item.TypeFor}` : item.PaymentType}{" - " + (item.Counter + 1)}
                                                            <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                                        </div>
                                                        <div className="col pt-2">
                                                            <p className="badge badge-warning" style={{ backgroundColor: "#ffc107c2" }}>Partial Payment</p>
                                                        </div>
                                                        {!roles[5] ?
                                                            <div className="col mt-2">
                                                                {/* {item.ApprovalDepartments.filter((data) => data.ActingDeptGroupId == 19).length == 0 ? this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.approvalStatus == 1 && data.DocumentTypeId == 0 && data.DocumentId == null && data.ActedGroupId == 19) ?
                                                                    <div className="float-right ml-1">
                                                                        <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                            <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>PM</div>
                                                                        </CircularProgressbarWithChildren>
                                                                    </div>
                                                                    : <div className="float-right ml-1">
                                                                        <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                            <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>PM</div>
                                                                        </CircularProgressbarWithChildren>
                                                                    </div>
                                                                    : null} */}
                                                                {/* {item.ApprovalDepartments.filter((data) => data.ActingDeptGroupId == 26).length == 0 ? this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.PoId == item.PoId && data.approvalStatus == 1 && data.DocumentTypeId == 0 && data.DocumentId == null && data.ActedGroupId == 26) ?
                                                                    <div className="float-right ml-1">
                                                                        <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                            <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>CM</div>
                                                                        </CircularProgressbarWithChildren>
                                                                    </div>
                                                                    : <div className="float-right ml-1">
                                                                        <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                            <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>CM</div>
                                                                        </CircularProgressbarWithChildren>
                                                                    </div>
                                                                    : null
                                                                } */}
                                                                 {item.ApprovalDepartments.filter((data) => data.ActingDeptGroupId == 7).length == 0 ?
                                                                    <div className="float-right ml-1">
                                                                        <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                            <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>EXP</div>
                                                                        </CircularProgressbarWithChildren>
                                                                    </div>
                                                                    : null
                                                                }
                                                                
                                                                {item.ApprovalDepartments.map((elem, index) =>
                                                                    <div key={index} className="float-right ml-1">
                                                                        <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={Math.round((elem.ApprovedCount / elem.TotalApprovalCount) * 100)}>
                                                                            <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>{elem.ShortDeptName}</div>
                                                                        </CircularProgressbarWithChildren>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            : null}
                                                    </div>
                                                </Accordion.Toggle>
                                            </Card>
                                            <Accordion.Collapse eventKey={JSON.stringify(index)}>
                                                <Card.Body>
                                                    {(roles[5] || (roles[7])) && item.Documents.find(el => this.state.paymentTermPartialDetails[el.AdvanceStageDocumentMappingIdPartial].approvalStatus == 0 && this.state.paymentTermPartialDetails[el.AdvanceStageDocumentMappingIdPartial].PaymentType == item.PaymentTypeId && this.state.paymentTermPartialDetails[el.AdvanceStageDocumentMappingIdPartial].TypeFor == item.TypeFor) ?
                                                        <div className="col-12">
                                                            <button className="float-right btn2 btn-sms1 rounded-pill" onClick={() => this.submitInvoiceDocumentsPartial(item)}>Submit Invoice</button>
                                                        </div>
                                                        : null}
                                                    {/* {item.PaymentType != "Dispatch" && item.Documents.filter((data) => data.ActingDeptGroupId == 19).length == 0 && roles[12] && this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.DocumentId != null && data.approvalStatus != 0) && !this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.approvalStatus == 1 && data.ActedGroupId == 19) ?
                                                        <div className="row">
                                                            <div className="col">
                                                                <button className="float-right btn2 btn-sms1 mr-4 rounded-pill" onClick={() => this.approveByCPMandTPMPartial(item, 19)}>Approve</button>
                                                            </div>
                                                        </div>
                                                        : null} */}
                                                    {/* {item.PaymentType != "Dispatch" && item.Documents.filter((data) => data.ActingDeptGroupId == 26).length == 0 && roles[19] && this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.DocumentId != null && data.approvalStatus != 0) && !this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.approvalStatus == 1 && data.ActedGroupId == 26) ?
                                                        <div className="row">
                                                            <div className="col">
                                                                <button className="float-right btn2 btn-sms1 mr-4 rounded-pill" onClick={() => this.approveByCPMandTPMPartial(item, 26)}>Approve</button>
                                                            </div>
                                                        </div>
                                                        : null} */}
                                                    <TableComp cols={partialPayment()} data={item.Documents.filter((data) => data.DocumentTypeId != null && data.DocumentTypeId != 0)} />
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </>
                                        : null
                                    }
                                </Accordion>
                            )}
                        </>
                        : null}
                    <hr></hr>
                    {/* document end */}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({ expediting: state.expediting,bgdraftDocReducer: state.bgDraftDocReducer, invoices: state.invoice, poDetails: state.poDetails, masterReducerData: state.masterReducer, expediting: state.expediting, file: state.file, dispatchOrderDetailsReducer: state.dispatchOrderDetailsReducer })
export default connect(mapStateToProps, {
    updateStatusForFinance, setInvoicePaymentMedium, getAllInvoices, getallMasterData, GetPaymentTermDetailByPOId, getBGListDetails, GetDraftDocuments,
    GetDocumentsForAdvance, postApprovePOAcceptance, GetBgDraftDocTableData, postUpdateAdvanceDocumentStatus, GetAllInvoicesForSupplier, GetPaymentTermDetails, postAdditionalEmailId,
    getPaymentTermDocuments, uploadFileGeneric, postMapAdvanceDocumentIDsToPO, InsertInvoiceDetails, GetAllCurrencyDetails, GenericUploadVersionFile, GenericGetCommentsbyDocumentID
    , GenericPostCommentsbyDocumentID, postPoTransmittleDocumnetDtails, GetTransmittalDocumentDetails, UpdateTransmittalDocumentDetails, PaymentTermDocumentsApprovalByPMs,
    submitInvoiceDocuments, GetInvoiceDetailsForAPteamApproval, UpdatePartialPaymentDetails, UpdateApprovalForAdvanceDocumentPartial, GetClaimDetailsByPoId, GetGRNDetails, postGRNDetails, postBGListDetails, getactionDetail
})(PoAcceptanceTrail)
